// Auto-generated curated cities list with population data
// Generated: 2025-10-05T19:26:01.423Z
// Total cities: 895

export interface CuratedCity {
    name: string
    countryCode: string
    stateCode: string
    population: number
    latitude: string
    longitude: string
    tier: 1 | 2 | 3 | 4
}

export const CURATED_CITIES: CuratedCity[] = [
  {
    "name": "Los Angeles",
    "countryCode": "US",
    "stateCode": "CA",
    "population": 3971883,
    "latitude": "34.05223",
    "longitude": "-118.24368",
    "tier": 1
  },
  {
    "name": "San Diego",
    "countryCode": "US",
    "stateCode": "CA",
    "population": 1394928,
    "latitude": "32.71571",
    "longitude": "-117.16472",
    "tier": 1
  },
  {
    "name": "San Jose",
    "countryCode": "US",
    "stateCode": "CA",
    "population": 1026908,
    "latitude": "37.33939",
    "longitude": "-121.89496",
    "tier": 1
  },
  {
    "name": "San Francisco",
    "countryCode": "US",
    "stateCode": "CA",
    "population": 864816,
    "latitude": "37.77493",
    "longitude": "-122.41942",
    "tier": 1
  },
  {
    "name": "Fresno",
    "countryCode": "US",
    "stateCode": "CA",
    "population": 520052,
    "latitude": "36.74773",
    "longitude": "-119.77237",
    "tier": 1
  },
  {
    "name": "Sacramento",
    "countryCode": "US",
    "stateCode": "CA",
    "population": 490712,
    "latitude": "38.58157",
    "longitude": "-121.4944",
    "tier": 1
  },
  {
    "name": "Long Beach",
    "countryCode": "US",
    "stateCode": "CA",
    "population": 474140,
    "latitude": "33.76696",
    "longitude": "-118.18923",
    "tier": 1
  },
  {
    "name": "Houston",
    "countryCode": "US",
    "stateCode": "TX",
    "population": 2296224,
    "latitude": "29.76328",
    "longitude": "-95.36327",
    "tier": 1
  },
  {
    "name": "San Antonio",
    "countryCode": "US",
    "stateCode": "TX",
    "population": 1469845,
    "latitude": "29.42412",
    "longitude": "-98.49363",
    "tier": 1
  },
  {
    "name": "Dallas",
    "countryCode": "US",
    "stateCode": "TX",
    "population": 1300092,
    "latitude": "32.78306",
    "longitude": "-96.80667",
    "tier": 1
  },
  {
    "name": "Austin",
    "countryCode": "US",
    "stateCode": "TX",
    "population": 931830,
    "latitude": "30.26715",
    "longitude": "-97.74306",
    "tier": 1
  },
  {
    "name": "Fort Worth",
    "countryCode": "US",
    "stateCode": "TX",
    "population": 833319,
    "latitude": "32.72541",
    "longitude": "-97.32085",
    "tier": 1
  },
  {
    "name": "El Paso",
    "countryCode": "US",
    "stateCode": "TX",
    "population": 681124,
    "latitude": "31.75872",
    "longitude": "-106.48693",
    "tier": 1
  },
  {
    "name": "Arlington",
    "countryCode": "US",
    "stateCode": "TX",
    "population": 388125,
    "latitude": "32.73569",
    "longitude": "-97.10807",
    "tier": 1
  },
  {
    "name": "Jacksonville",
    "countryCode": "US",
    "stateCode": "FL",
    "population": 868031,
    "latitude": "30.33218",
    "longitude": "-81.65565",
    "tier": 1
  },
  {
    "name": "Miami",
    "countryCode": "US",
    "stateCode": "FL",
    "population": 441003,
    "latitude": "25.77427",
    "longitude": "-80.19366",
    "tier": 1
  },
  {
    "name": "Tampa",
    "countryCode": "US",
    "stateCode": "FL",
    "population": 369075,
    "latitude": "27.94752",
    "longitude": "-82.45843",
    "tier": 1
  },
  {
    "name": "Orlando",
    "countryCode": "US",
    "stateCode": "FL",
    "population": 270934,
    "latitude": "28.53834",
    "longitude": "-81.37924",
    "tier": 1
  },
  {
    "name": "St. Petersburg",
    "countryCode": "US",
    "stateCode": "FL",
    "population": 257083,
    "latitude": "27.77086",
    "longitude": "-82.67927",
    "tier": 1
  },
  {
    "name": "Hialeah",
    "countryCode": "US",
    "stateCode": "FL",
    "population": 237069,
    "latitude": "25.8576",
    "longitude": "-80.27811",
    "tier": 1
  },
  {
    "name": "Tallahassee",
    "countryCode": "US",
    "stateCode": "FL",
    "population": 189907,
    "latitude": "30.43826",
    "longitude": "-84.28073",
    "tier": 1
  },
  {
    "name": "New York City",
    "countryCode": "US",
    "stateCode": "NY",
    "population": 8175133,
    "latitude": "40.71427",
    "longitude": "-74.00597",
    "tier": 1
  },
  {
    "name": "Brooklyn",
    "countryCode": "US",
    "stateCode": "NY",
    "population": 2300664,
    "latitude": "40.6501",
    "longitude": "-73.94958",
    "tier": 1
  },
  {
    "name": "Queens",
    "countryCode": "US",
    "stateCode": "NY",
    "population": 2272771,
    "latitude": "40.68149",
    "longitude": "-73.83652",
    "tier": 1
  },
  {
    "name": "Manhattan",
    "countryCode": "US",
    "stateCode": "NY",
    "population": 1487536,
    "latitude": "40.78343",
    "longitude": "-73.96625",
    "tier": 1
  },
  {
    "name": "The Bronx",
    "countryCode": "US",
    "stateCode": "NY",
    "population": 1385108,
    "latitude": "40.84985",
    "longitude": "-73.86641",
    "tier": 1
  },
  {
    "name": "Staten Island",
    "countryCode": "US",
    "stateCode": "NY",
    "population": 468730,
    "latitude": "40.56233",
    "longitude": "-74.13986",
    "tier": 1
  },
  {
    "name": "Buffalo",
    "countryCode": "US",
    "stateCode": "NY",
    "population": 258071,
    "latitude": "42.88645",
    "longitude": "-78.87837",
    "tier": 1
  },
  {
    "name": "Philadelphia",
    "countryCode": "US",
    "stateCode": "PA",
    "population": 1567442,
    "latitude": "39.95233",
    "longitude": "-75.16379",
    "tier": 1
  },
  {
    "name": "Pittsburgh",
    "countryCode": "US",
    "stateCode": "PA",
    "population": 304391,
    "latitude": "40.44062",
    "longitude": "-79.99589",
    "tier": 1
  },
  {
    "name": "Allentown",
    "countryCode": "US",
    "stateCode": "PA",
    "population": 120207,
    "latitude": "40.60843",
    "longitude": "-75.49018",
    "tier": 1
  },
  {
    "name": "Erie",
    "countryCode": "US",
    "stateCode": "PA",
    "population": 99475,
    "latitude": "42.12922",
    "longitude": "-80.08506",
    "tier": 1
  },
  {
    "name": "Reading",
    "countryCode": "US",
    "stateCode": "PA",
    "population": 87879,
    "latitude": "40.33565",
    "longitude": "-75.92687",
    "tier": 1
  },
  {
    "name": "Scranton",
    "countryCode": "US",
    "stateCode": "PA",
    "population": 77118,
    "latitude": "41.40916",
    "longitude": "-75.6649",
    "tier": 1
  },
  {
    "name": "Bethlehem",
    "countryCode": "US",
    "stateCode": "PA",
    "population": 74892,
    "latitude": "40.62593",
    "longitude": "-75.37046",
    "tier": 1
  },
  {
    "name": "Chicago",
    "countryCode": "US",
    "stateCode": "IL",
    "population": 2720546,
    "latitude": "41.85003",
    "longitude": "-87.65005",
    "tier": 1
  },
  {
    "name": "Aurora",
    "countryCode": "US",
    "stateCode": "IL",
    "population": 200661,
    "latitude": "41.76058",
    "longitude": "-88.32007",
    "tier": 1
  },
  {
    "name": "Rockford",
    "countryCode": "US",
    "stateCode": "IL",
    "population": 148278,
    "latitude": "42.27113",
    "longitude": "-89.094",
    "tier": 1
  },
  {
    "name": "Joliet",
    "countryCode": "US",
    "stateCode": "IL",
    "population": 147861,
    "latitude": "41.52519",
    "longitude": "-88.0834",
    "tier": 1
  },
  {
    "name": "Naperville",
    "countryCode": "US",
    "stateCode": "IL",
    "population": 147100,
    "latitude": "41.78586",
    "longitude": "-88.14729",
    "tier": 1
  },
  {
    "name": "Springfield",
    "countryCode": "US",
    "stateCode": "IL",
    "population": 116565,
    "latitude": "39.80172",
    "longitude": "-89.64371",
    "tier": 1
  },
  {
    "name": "Peoria",
    "countryCode": "US",
    "stateCode": "IL",
    "population": 115070,
    "latitude": "40.69365",
    "longitude": "-89.58899",
    "tier": 1
  },
  {
    "name": "Columbus",
    "countryCode": "US",
    "stateCode": "OH",
    "population": 850106,
    "latitude": "39.96118",
    "longitude": "-82.99879",
    "tier": 1
  },
  {
    "name": "Cleveland",
    "countryCode": "US",
    "stateCode": "OH",
    "population": 388072,
    "latitude": "41.4995",
    "longitude": "-81.69541",
    "tier": 1
  },
  {
    "name": "Cincinnati",
    "countryCode": "US",
    "stateCode": "OH",
    "population": 296943,
    "latitude": "39.12711",
    "longitude": "-84.51439",
    "tier": 1
  },
  {
    "name": "Toledo",
    "countryCode": "US",
    "stateCode": "OH",
    "population": 279789,
    "latitude": "41.66394",
    "longitude": "-83.55521",
    "tier": 1
  },
  {
    "name": "Akron",
    "countryCode": "US",
    "stateCode": "OH",
    "population": 197542,
    "latitude": "41.08144",
    "longitude": "-81.51901",
    "tier": 1
  },
  {
    "name": "Dayton",
    "countryCode": "US",
    "stateCode": "OH",
    "population": 140599,
    "latitude": "39.75895",
    "longitude": "-84.19161",
    "tier": 1
  },
  {
    "name": "Parma",
    "countryCode": "US",
    "stateCode": "OH",
    "population": 79937,
    "latitude": "41.40477",
    "longitude": "-81.72291",
    "tier": 1
  },
  {
    "name": "Atlanta",
    "countryCode": "US",
    "stateCode": "GA",
    "population": 463878,
    "latitude": "33.749",
    "longitude": "-84.38798",
    "tier": 1
  },
  {
    "name": "Columbus",
    "countryCode": "US",
    "stateCode": "GA",
    "population": 200579,
    "latitude": "32.46098",
    "longitude": "-84.98771",
    "tier": 1
  },
  {
    "name": "Savannah",
    "countryCode": "US",
    "stateCode": "GA",
    "population": 145674,
    "latitude": "32.08354",
    "longitude": "-81.09983",
    "tier": 1
  },
  {
    "name": "Athens",
    "countryCode": "US",
    "stateCode": "GA",
    "population": 116714,
    "latitude": "33.96095",
    "longitude": "-83.37794",
    "tier": 1
  },
  {
    "name": "Sandy Springs",
    "countryCode": "US",
    "stateCode": "GA",
    "population": 105330,
    "latitude": "33.92427",
    "longitude": "-84.37854",
    "tier": 1
  },
  {
    "name": "Roswell",
    "countryCode": "US",
    "stateCode": "GA",
    "population": 94501,
    "latitude": "34.02316",
    "longitude": "-84.36159",
    "tier": 1
  },
  {
    "name": "Macon",
    "countryCode": "US",
    "stateCode": "GA",
    "population": 91351,
    "latitude": "32.84069",
    "longitude": "-83.6324",
    "tier": 1
  },
  {
    "name": "Charlotte",
    "countryCode": "US",
    "stateCode": "NC",
    "population": 827097,
    "latitude": "35.22709",
    "longitude": "-80.84313",
    "tier": 1
  },
  {
    "name": "Raleigh",
    "countryCode": "US",
    "stateCode": "NC",
    "population": 451066,
    "latitude": "35.7721",
    "longitude": "-78.63861",
    "tier": 1
  },
  {
    "name": "West Raleigh",
    "countryCode": "US",
    "stateCode": "NC",
    "population": 338759,
    "latitude": "35.78682",
    "longitude": "-78.66389",
    "tier": 1
  },
  {
    "name": "Greensboro",
    "countryCode": "US",
    "stateCode": "NC",
    "population": 285342,
    "latitude": "36.07264",
    "longitude": "-79.79198",
    "tier": 1
  },
  {
    "name": "Durham",
    "countryCode": "US",
    "stateCode": "NC",
    "population": 257636,
    "latitude": "35.99403",
    "longitude": "-78.89862",
    "tier": 1
  },
  {
    "name": "Winston-Salem",
    "countryCode": "US",
    "stateCode": "NC",
    "population": 241218,
    "latitude": "36.09986",
    "longitude": "-80.24422",
    "tier": 1
  },
  {
    "name": "Fayetteville",
    "countryCode": "US",
    "stateCode": "NC",
    "population": 201963,
    "latitude": "35.05266",
    "longitude": "-78.87836",
    "tier": 1
  },
  {
    "name": "Detroit",
    "countryCode": "US",
    "stateCode": "MI",
    "population": 677116,
    "latitude": "42.33143",
    "longitude": "-83.04575",
    "tier": 1
  },
  {
    "name": "Grand Rapids",
    "countryCode": "US",
    "stateCode": "MI",
    "population": 195097,
    "latitude": "42.96336",
    "longitude": "-85.66809",
    "tier": 1
  },
  {
    "name": "Warren",
    "countryCode": "US",
    "stateCode": "MI",
    "population": 134056,
    "latitude": "42.49044",
    "longitude": "-83.01304",
    "tier": 1
  },
  {
    "name": "Sterling Heights",
    "countryCode": "US",
    "stateCode": "MI",
    "population": 132052,
    "latitude": "42.58031",
    "longitude": "-83.0302",
    "tier": 1
  },
  {
    "name": "Ann Arbor",
    "countryCode": "US",
    "stateCode": "MI",
    "population": 117070,
    "latitude": "42.27756",
    "longitude": "-83.74088",
    "tier": 1
  },
  {
    "name": "Lansing",
    "countryCode": "US",
    "stateCode": "MI",
    "population": 115056,
    "latitude": "42.73253",
    "longitude": "-84.55553",
    "tier": 1
  },
  {
    "name": "Clinton Township",
    "countryCode": "US",
    "stateCode": "MI",
    "population": 99753,
    "latitude": "42.58698",
    "longitude": "-82.91992",
    "tier": 1
  },
  {
    "name": "Seattle",
    "countryCode": "US",
    "stateCode": "WA",
    "population": 684451,
    "latitude": "47.60621",
    "longitude": "-122.33207",
    "tier": 1
  },
  {
    "name": "Spokane",
    "countryCode": "US",
    "stateCode": "WA",
    "population": 213272,
    "latitude": "47.65966",
    "longitude": "-117.42908",
    "tier": 1
  },
  {
    "name": "Tacoma",
    "countryCode": "US",
    "stateCode": "WA",
    "population": 207948,
    "latitude": "47.25288",
    "longitude": "-122.44429",
    "tier": 1
  },
  {
    "name": "Vancouver",
    "countryCode": "US",
    "stateCode": "WA",
    "population": 172860,
    "latitude": "45.63873",
    "longitude": "-122.66149",
    "tier": 1
  },
  {
    "name": "Bellevue",
    "countryCode": "US",
    "stateCode": "WA",
    "population": 139820,
    "latitude": "47.61038",
    "longitude": "-122.20068",
    "tier": 1
  },
  {
    "name": "Denver",
    "countryCode": "US",
    "stateCode": "CO",
    "population": 682545,
    "latitude": "39.73915",
    "longitude": "-104.9847",
    "tier": 1
  },
  {
    "name": "Colorado Springs",
    "countryCode": "US",
    "stateCode": "CO",
    "population": 456568,
    "latitude": "38.83388",
    "longitude": "-104.82136",
    "tier": 1
  },
  {
    "name": "Aurora",
    "countryCode": "US",
    "stateCode": "CO",
    "population": 359407,
    "latitude": "39.72943",
    "longitude": "-104.83192",
    "tier": 1
  },
  {
    "name": "Fort Collins",
    "countryCode": "US",
    "stateCode": "CO",
    "population": 161175,
    "latitude": "40.58526",
    "longitude": "-105.08442",
    "tier": 1
  },
  {
    "name": "Lakewood",
    "countryCode": "US",
    "stateCode": "CO",
    "population": 152597,
    "latitude": "39.70471",
    "longitude": "-105.08137",
    "tier": 1
  },
  {
    "name": "Phoenix",
    "countryCode": "US",
    "stateCode": "AZ",
    "population": 1563025,
    "latitude": "33.44838",
    "longitude": "-112.07404",
    "tier": 1
  },
  {
    "name": "Tucson",
    "countryCode": "US",
    "stateCode": "AZ",
    "population": 531641,
    "latitude": "32.22174",
    "longitude": "-110.92648",
    "tier": 1
  },
  {
    "name": "Mesa",
    "countryCode": "US",
    "stateCode": "AZ",
    "population": 471825,
    "latitude": "33.42227",
    "longitude": "-111.82264",
    "tier": 1
  },
  {
    "name": "Chandler",
    "countryCode": "US",
    "stateCode": "AZ",
    "population": 260828,
    "latitude": "33.30616",
    "longitude": "-111.84125",
    "tier": 1
  },
  {
    "name": "Gilbert",
    "countryCode": "US",
    "stateCode": "AZ",
    "population": 247542,
    "latitude": "33.35283",
    "longitude": "-111.78903",
    "tier": 1
  },
  {
    "name": "Boston",
    "countryCode": "US",
    "stateCode": "MA",
    "population": 667137,
    "latitude": "42.35843",
    "longitude": "-71.05977",
    "tier": 1
  },
  {
    "name": "South Boston",
    "countryCode": "US",
    "stateCode": "MA",
    "population": 571281,
    "latitude": "42.33343",
    "longitude": "-71.04949",
    "tier": 1
  },
  {
    "name": "Worcester",
    "countryCode": "US",
    "stateCode": "MA",
    "population": 184815,
    "latitude": "42.26259",
    "longitude": "-71.80229",
    "tier": 1
  },
  {
    "name": "Springfield",
    "countryCode": "US",
    "stateCode": "MA",
    "population": 154341,
    "latitude": "42.10148",
    "longitude": "-72.58981",
    "tier": 1
  },
  {
    "name": "Lowell",
    "countryCode": "US",
    "stateCode": "MA",
    "population": 110699,
    "latitude": "42.63342",
    "longitude": "-71.31617",
    "tier": 1
  },
  {
    "name": "Memphis",
    "countryCode": "US",
    "stateCode": "TN",
    "population": 655770,
    "latitude": "35.14953",
    "longitude": "-90.04898",
    "tier": 1
  },
  {
    "name": "New South Memphis",
    "countryCode": "US",
    "stateCode": "TN",
    "population": 641608,
    "latitude": "35.08676",
    "longitude": "-90.05676",
    "tier": 1
  },
  {
    "name": "Nashville",
    "countryCode": "US",
    "stateCode": "TN",
    "population": 530852,
    "latitude": "36.16589",
    "longitude": "-86.78444",
    "tier": 1
  },
  {
    "name": "Knoxville",
    "countryCode": "US",
    "stateCode": "TN",
    "population": 185291,
    "latitude": "35.96064",
    "longitude": "-83.92074",
    "tier": 1
  },
  {
    "name": "Chattanooga",
    "countryCode": "US",
    "stateCode": "TN",
    "population": 176588,
    "latitude": "35.04563",
    "longitude": "-85.30968",
    "tier": 1
  },
  {
    "name": "Indianapolis",
    "countryCode": "US",
    "stateCode": "IN",
    "population": 829718,
    "latitude": "39.76838",
    "longitude": "-86.15804",
    "tier": 1
  },
  {
    "name": "Fort Wayne",
    "countryCode": "US",
    "stateCode": "IN",
    "population": 260326,
    "latitude": "41.1306",
    "longitude": "-85.12886",
    "tier": 1
  },
  {
    "name": "Evansville",
    "countryCode": "US",
    "stateCode": "IN",
    "population": 119943,
    "latitude": "37.97476",
    "longitude": "-87.55585",
    "tier": 1
  },
  {
    "name": "South Bend",
    "countryCode": "US",
    "stateCode": "IN",
    "population": 101516,
    "latitude": "41.68338",
    "longitude": "-86.25001",
    "tier": 1
  },
  {
    "name": "Carmel",
    "countryCode": "US",
    "stateCode": "IN",
    "population": 88713,
    "latitude": "39.97837",
    "longitude": "-86.11804",
    "tier": 1
  },
  {
    "name": "Kansas City",
    "countryCode": "US",
    "stateCode": "MO",
    "population": 475378,
    "latitude": "39.09973",
    "longitude": "-94.57857",
    "tier": 1
  },
  {
    "name": "St. Louis",
    "countryCode": "US",
    "stateCode": "MO",
    "population": 315685,
    "latitude": "38.62727",
    "longitude": "-90.19789",
    "tier": 1
  },
  {
    "name": "Springfield",
    "countryCode": "US",
    "stateCode": "MO",
    "population": 166810,
    "latitude": "37.21533",
    "longitude": "-93.29824",
    "tier": 1
  },
  {
    "name": "Columbia",
    "countryCode": "US",
    "stateCode": "MO",
    "population": 119108,
    "latitude": "38.95171",
    "longitude": "-92.33407",
    "tier": 1
  },
  {
    "name": "Independence",
    "countryCode": "US",
    "stateCode": "MO",
    "population": 117255,
    "latitude": "39.09112",
    "longitude": "-94.41551",
    "tier": 1
  },
  {
    "name": "Baltimore",
    "countryCode": "US",
    "stateCode": "MD",
    "population": 621849,
    "latitude": "39.29038",
    "longitude": "-76.61219",
    "tier": 1
  },
  {
    "name": "Columbia",
    "countryCode": "US",
    "stateCode": "MD",
    "population": 99615,
    "latitude": "39.24038",
    "longitude": "-76.83942",
    "tier": 1
  },
  {
    "name": "Germantown",
    "countryCode": "US",
    "stateCode": "MD",
    "population": 86395,
    "latitude": "39.17316",
    "longitude": "-77.27165",
    "tier": 1
  },
  {
    "name": "Silver Spring",
    "countryCode": "US",
    "stateCode": "MD",
    "population": 71452,
    "latitude": "38.99067",
    "longitude": "-77.02609",
    "tier": 1
  },
  {
    "name": "Frederick",
    "countryCode": "US",
    "stateCode": "MD",
    "population": 69479,
    "latitude": "39.41427",
    "longitude": "-77.41054",
    "tier": 1
  },
  {
    "name": "Milwaukee",
    "countryCode": "US",
    "stateCode": "WI",
    "population": 600155,
    "latitude": "43.0389",
    "longitude": "-87.90647",
    "tier": 1
  },
  {
    "name": "Madison",
    "countryCode": "US",
    "stateCode": "WI",
    "population": 248951,
    "latitude": "43.07305",
    "longitude": "-89.40123",
    "tier": 1
  },
  {
    "name": "Green Bay",
    "countryCode": "US",
    "stateCode": "WI",
    "population": 105207,
    "latitude": "44.51916",
    "longitude": "-88.01983",
    "tier": 1
  },
  {
    "name": "Kenosha",
    "countryCode": "US",
    "stateCode": "WI",
    "population": 99858,
    "latitude": "42.58474",
    "longitude": "-87.82119",
    "tier": 1
  },
  {
    "name": "Racine",
    "countryCode": "US",
    "stateCode": "WI",
    "population": 77742,
    "latitude": "42.72613",
    "longitude": "-87.78285",
    "tier": 1
  },
  {
    "name": "Minneapolis",
    "countryCode": "US",
    "stateCode": "MN",
    "population": 410939,
    "latitude": "44.97997",
    "longitude": "-93.26384",
    "tier": 1
  },
  {
    "name": "Saint Paul",
    "countryCode": "US",
    "stateCode": "MN",
    "population": 285068,
    "latitude": "44.94441",
    "longitude": "-93.09327",
    "tier": 1
  },
  {
    "name": "Rochester",
    "countryCode": "US",
    "stateCode": "MN",
    "population": 112225,
    "latitude": "44.02163",
    "longitude": "-92.4699",
    "tier": 1
  },
  {
    "name": "Bloomington",
    "countryCode": "US",
    "stateCode": "MN",
    "population": 86435,
    "latitude": "44.8408",
    "longitude": "-93.29828",
    "tier": 1
  },
  {
    "name": "Duluth",
    "countryCode": "US",
    "stateCode": "MN",
    "population": 86110,
    "latitude": "46.78327",
    "longitude": "-92.10658",
    "tier": 1
  },
  {
    "name": "Columbia",
    "countryCode": "US",
    "stateCode": "SC",
    "population": 133803,
    "latitude": "34.00071",
    "longitude": "-81.03481",
    "tier": 1
  },
  {
    "name": "Charleston",
    "countryCode": "US",
    "stateCode": "SC",
    "population": 132609,
    "latitude": "32.77657",
    "longitude": "-79.93092",
    "tier": 1
  },
  {
    "name": "North Charleston",
    "countryCode": "US",
    "stateCode": "SC",
    "population": 108304,
    "latitude": "32.85462",
    "longitude": "-79.97481",
    "tier": 1
  },
  {
    "name": "Mount Pleasant",
    "countryCode": "US",
    "stateCode": "SC",
    "population": 81317,
    "latitude": "32.79407",
    "longitude": "-79.86259",
    "tier": 1
  },
  {
    "name": "Rock Hill",
    "countryCode": "US",
    "stateCode": "SC",
    "population": 71548,
    "latitude": "34.92487",
    "longitude": "-81.02508",
    "tier": 1
  },
  {
    "name": "Birmingham",
    "countryCode": "US",
    "stateCode": "AL",
    "population": 212461,
    "latitude": "33.52066",
    "longitude": "-86.80249",
    "tier": 1
  },
  {
    "name": "Montgomery",
    "countryCode": "US",
    "stateCode": "AL",
    "population": 200602,
    "latitude": "32.36681",
    "longitude": "-86.29997",
    "tier": 1
  },
  {
    "name": "Mobile",
    "countryCode": "US",
    "stateCode": "AL",
    "population": 194288,
    "latitude": "30.69436",
    "longitude": "-88.04305",
    "tier": 1
  },
  {
    "name": "Huntsville",
    "countryCode": "US",
    "stateCode": "AL",
    "population": 190582,
    "latitude": "34.7304",
    "longitude": "-86.58594",
    "tier": 1
  },
  {
    "name": "Tuscaloosa",
    "countryCode": "US",
    "stateCode": "AL",
    "population": 98332,
    "latitude": "33.20984",
    "longitude": "-87.56917",
    "tier": 1
  },
  {
    "name": "New Orleans",
    "countryCode": "US",
    "stateCode": "LA",
    "population": 389617,
    "latitude": "29.95465",
    "longitude": "-90.07507",
    "tier": 1
  },
  {
    "name": "Baton Rouge",
    "countryCode": "US",
    "stateCode": "LA",
    "population": 228590,
    "latitude": "30.44332",
    "longitude": "-91.18747",
    "tier": 1
  },
  {
    "name": "Shreveport",
    "countryCode": "US",
    "stateCode": "LA",
    "population": 197204,
    "latitude": "32.52515",
    "longitude": "-93.75018",
    "tier": 1
  },
  {
    "name": "Metairie Terrace",
    "countryCode": "US",
    "stateCode": "LA",
    "population": 142489,
    "latitude": "29.97854",
    "longitude": "-90.16396",
    "tier": 1
  },
  {
    "name": "Metairie",
    "countryCode": "US",
    "stateCode": "LA",
    "population": 138481,
    "latitude": "29.98409",
    "longitude": "-90.15285",
    "tier": 1
  },
  {
    "name": "Lexington-Fayette",
    "countryCode": "US",
    "stateCode": "KY",
    "population": 314488,
    "latitude": "38.0498",
    "longitude": "-84.45855",
    "tier": 1
  },
  {
    "name": "Ironville",
    "countryCode": "US",
    "stateCode": "KY",
    "population": 288649,
    "latitude": "38.45647",
    "longitude": "-82.69238",
    "tier": 1
  },
  {
    "name": "Meads",
    "countryCode": "US",
    "stateCode": "KY",
    "population": 288649,
    "latitude": "38.41258",
    "longitude": "-82.70905",
    "tier": 1
  },
  {
    "name": "Louisville",
    "countryCode": "US",
    "stateCode": "KY",
    "population": 243639,
    "latitude": "38.25424",
    "longitude": "-85.75941",
    "tier": 1
  },
  {
    "name": "Lexington",
    "countryCode": "US",
    "stateCode": "KY",
    "population": 225366,
    "latitude": "37.98869",
    "longitude": "-84.47772",
    "tier": 1
  },
  {
    "name": "Portland",
    "countryCode": "US",
    "stateCode": "OR",
    "population": 632309,
    "latitude": "45.52345",
    "longitude": "-122.67621",
    "tier": 1
  },
  {
    "name": "Salem",
    "countryCode": "US",
    "stateCode": "OR",
    "population": 164549,
    "latitude": "44.9429",
    "longitude": "-123.0351",
    "tier": 1
  },
  {
    "name": "Eugene",
    "countryCode": "US",
    "stateCode": "OR",
    "population": 163460,
    "latitude": "44.05207",
    "longitude": "-123.08675",
    "tier": 1
  },
  {
    "name": "Gresham",
    "countryCode": "US",
    "stateCode": "OR",
    "population": 110553,
    "latitude": "45.49818",
    "longitude": "-122.43148",
    "tier": 1
  },
  {
    "name": "Hillsboro",
    "countryCode": "US",
    "stateCode": "OR",
    "population": 102347,
    "latitude": "45.52289",
    "longitude": "-122.98983",
    "tier": 1
  },
  {
    "name": "Oklahoma City",
    "countryCode": "US",
    "stateCode": "OK",
    "population": 631346,
    "latitude": "35.46756",
    "longitude": "-97.51643",
    "tier": 1
  },
  {
    "name": "Tulsa",
    "countryCode": "US",
    "stateCode": "OK",
    "population": 403505,
    "latitude": "36.15398",
    "longitude": "-95.99277",
    "tier": 1
  },
  {
    "name": "Norman",
    "countryCode": "US",
    "stateCode": "OK",
    "population": 120284,
    "latitude": "35.22257",
    "longitude": "-97.43948",
    "tier": 1
  },
  {
    "name": "Broken Arrow",
    "countryCode": "US",
    "stateCode": "OK",
    "population": 106563,
    "latitude": "36.0526",
    "longitude": "-95.79082",
    "tier": 1
  },
  {
    "name": "Lawton",
    "countryCode": "US",
    "stateCode": "OK",
    "population": 96655,
    "latitude": "34.60869",
    "longitude": "-98.39033",
    "tier": 1
  },
  {
    "name": "Bridgeport",
    "countryCode": "US",
    "stateCode": "CT",
    "population": 147629,
    "latitude": "41.17923",
    "longitude": "-73.18945",
    "tier": 1
  },
  {
    "name": "New Haven",
    "countryCode": "US",
    "stateCode": "CT",
    "population": 130322,
    "latitude": "41.30815",
    "longitude": "-72.92816",
    "tier": 1
  },
  {
    "name": "Stamford",
    "countryCode": "US",
    "stateCode": "CT",
    "population": 128874,
    "latitude": "41.05343",
    "longitude": "-73.53873",
    "tier": 1
  },
  {
    "name": "Hartford",
    "countryCode": "US",
    "stateCode": "CT",
    "population": 124006,
    "latitude": "41.76371",
    "longitude": "-72.68509",
    "tier": 1
  },
  {
    "name": "North Stamford",
    "countryCode": "US",
    "stateCode": "CT",
    "population": 121230,
    "latitude": "41.13815",
    "longitude": "-73.54346",
    "tier": 1
  },
  {
    "name": "Salt Lake City",
    "countryCode": "US",
    "stateCode": "UT",
    "population": 192672,
    "latitude": "40.76078",
    "longitude": "-111.89105",
    "tier": 1
  },
  {
    "name": "West Valley City",
    "countryCode": "US",
    "stateCode": "UT",
    "population": 136208,
    "latitude": "40.69161",
    "longitude": "-112.00105",
    "tier": 1
  },
  {
    "name": "Provo",
    "countryCode": "US",
    "stateCode": "UT",
    "population": 115264,
    "latitude": "40.23384",
    "longitude": "-111.65853",
    "tier": 1
  },
  {
    "name": "West Jordan",
    "countryCode": "US",
    "stateCode": "UT",
    "population": 111946,
    "latitude": "40.60967",
    "longitude": "-111.9391",
    "tier": 1
  },
  {
    "name": "Orem",
    "countryCode": "US",
    "stateCode": "UT",
    "population": 94457,
    "latitude": "40.2969",
    "longitude": "-111.69465",
    "tier": 1
  },
  {
    "name": "Las Vegas",
    "countryCode": "US",
    "stateCode": "NV",
    "population": 623747,
    "latitude": "36.17497",
    "longitude": "-115.13722",
    "tier": 1
  },
  {
    "name": "Henderson",
    "countryCode": "US",
    "stateCode": "NV",
    "population": 285667,
    "latitude": "36.0397",
    "longitude": "-114.98194",
    "tier": 1
  },
  {
    "name": "Reno",
    "countryCode": "US",
    "stateCode": "NV",
    "population": 241445,
    "latitude": "39.52963",
    "longitude": "-119.8138",
    "tier": 1
  },
  {
    "name": "North Las Vegas",
    "countryCode": "US",
    "stateCode": "NV",
    "population": 234807,
    "latitude": "36.19886",
    "longitude": "-115.1175",
    "tier": 1
  },
  {
    "name": "Paradise",
    "countryCode": "US",
    "stateCode": "NV",
    "population": 223167,
    "latitude": "36.09719",
    "longitude": "-115.14666",
    "tier": 1
  },
  {
    "name": "Albuquerque",
    "countryCode": "US",
    "stateCode": "NM",
    "population": 559121,
    "latitude": "35.08449",
    "longitude": "-106.65114",
    "tier": 1
  },
  {
    "name": "Las Cruces",
    "countryCode": "US",
    "stateCode": "NM",
    "population": 101643,
    "latitude": "32.31232",
    "longitude": "-106.77834",
    "tier": 1
  },
  {
    "name": "Rio Rancho",
    "countryCode": "US",
    "stateCode": "NM",
    "population": 87521,
    "latitude": "35.23338",
    "longitude": "-106.66447",
    "tier": 1
  },
  {
    "name": "Enchanted Hills",
    "countryCode": "US",
    "stateCode": "NM",
    "population": 87521,
    "latitude": "35.33676",
    "longitude": "-106.59296",
    "tier": 1
  },
  {
    "name": "Santa Fe",
    "countryCode": "US",
    "stateCode": "NM",
    "population": 84099,
    "latitude": "35.68698",
    "longitude": "-105.9378",
    "tier": 1
  },
  {
    "name": "Little Rock",
    "countryCode": "US",
    "stateCode": "AR",
    "population": 197992,
    "latitude": "34.74648",
    "longitude": "-92.28959",
    "tier": 1
  },
  {
    "name": "Fort Smith",
    "countryCode": "US",
    "stateCode": "AR",
    "population": 88194,
    "latitude": "35.38592",
    "longitude": "-94.39855",
    "tier": 1
  },
  {
    "name": "Fayetteville",
    "countryCode": "US",
    "stateCode": "AR",
    "population": 82830,
    "latitude": "36.06258",
    "longitude": "-94.15743",
    "tier": 1
  },
  {
    "name": "Springdale",
    "countryCode": "US",
    "stateCode": "AR",
    "population": 77859,
    "latitude": "36.18674",
    "longitude": "-94.12881",
    "tier": 1
  },
  {
    "name": "Jonesboro",
    "countryCode": "US",
    "stateCode": "AR",
    "population": 73907,
    "latitude": "35.8423",
    "longitude": "-90.70428",
    "tier": 1
  },
  {
    "name": "Jackson",
    "countryCode": "US",
    "stateCode": "MS",
    "population": 170674,
    "latitude": "32.29876",
    "longitude": "-90.18481",
    "tier": 1
  },
  {
    "name": "Gulfport",
    "countryCode": "US",
    "stateCode": "MS",
    "population": 71856,
    "latitude": "30.36742",
    "longitude": "-89.09282",
    "tier": 1
  },
  {
    "name": "West Gulfport",
    "countryCode": "US",
    "stateCode": "MS",
    "population": 71329,
    "latitude": "30.40409",
    "longitude": "-89.0942",
    "tier": 1
  },
  {
    "name": "Southaven",
    "countryCode": "US",
    "stateCode": "MS",
    "population": 52589,
    "latitude": "34.98898",
    "longitude": "-90.01259",
    "tier": 1
  },
  {
    "name": "Hattiesburg",
    "countryCode": "US",
    "stateCode": "MS",
    "population": 46805,
    "latitude": "31.32712",
    "longitude": "-89.29034",
    "tier": 1
  },
  {
    "name": "Wichita",
    "countryCode": "US",
    "stateCode": "KS",
    "population": 389965,
    "latitude": "37.69224",
    "longitude": "-97.33754",
    "tier": 1
  },
  {
    "name": "Overland Park",
    "countryCode": "US",
    "stateCode": "KS",
    "population": 186515,
    "latitude": "38.98223",
    "longitude": "-94.67079",
    "tier": 1
  },
  {
    "name": "Kansas City",
    "countryCode": "US",
    "stateCode": "KS",
    "population": 151306,
    "latitude": "39.11417",
    "longitude": "-94.62746",
    "tier": 1
  },
  {
    "name": "Olathe",
    "countryCode": "US",
    "stateCode": "KS",
    "population": 134305,
    "latitude": "38.8814",
    "longitude": "-94.81913",
    "tier": 1
  },
  {
    "name": "Topeka",
    "countryCode": "US",
    "stateCode": "KS",
    "population": 127265,
    "latitude": "39.04833",
    "longitude": "-95.67804",
    "tier": 1
  },
  {
    "name": "Virginia Beach",
    "countryCode": "US",
    "stateCode": "VA",
    "population": 452745,
    "latitude": "36.85293",
    "longitude": "-75.97799",
    "tier": 1
  },
  {
    "name": "Norfolk",
    "countryCode": "US",
    "stateCode": "VA",
    "population": 246393,
    "latitude": "36.84681",
    "longitude": "-76.28522",
    "tier": 1
  },
  {
    "name": "Chesapeake",
    "countryCode": "US",
    "stateCode": "VA",
    "population": 235429,
    "latitude": "36.81904",
    "longitude": "-76.27494",
    "tier": 1
  },
  {
    "name": "Wilmington",
    "countryCode": "US",
    "stateCode": "DE",
    "population": 71948,
    "latitude": "39.74595",
    "longitude": "-75.54659",
    "tier": 1
  },
  {
    "name": "Dover",
    "countryCode": "US",
    "stateCode": "DE",
    "population": 37522,
    "latitude": "39.15817",
    "longitude": "-75.52437",
    "tier": 1
  },
  {
    "name": "Newark",
    "countryCode": "US",
    "stateCode": "DE",
    "population": 33817,
    "latitude": "39.68372",
    "longitude": "-75.74966",
    "tier": 1
  },
  {
    "name": "Washington, D.C.",
    "countryCode": "US",
    "stateCode": "DC",
    "population": 601723,
    "latitude": "38.89511",
    "longitude": "-77.03637",
    "tier": 1
  },
  {
    "name": "Shaw",
    "countryCode": "US",
    "stateCode": "DC",
    "population": 17639,
    "latitude": "38.91206",
    "longitude": "-77.02137",
    "tier": 1
  },
  {
    "name": "Adams Morgan",
    "countryCode": "US",
    "stateCode": "DC",
    "population": 15830,
    "latitude": "38.9215",
    "longitude": "-77.0422",
    "tier": 1
  },
  {
    "name": "Newark",
    "countryCode": "US",
    "stateCode": "NJ",
    "population": 281944,
    "latitude": "40.73566",
    "longitude": "-74.17237",
    "tier": 1
  },
  {
    "name": "Jersey City",
    "countryCode": "US",
    "stateCode": "NJ",
    "population": 264290,
    "latitude": "40.72816",
    "longitude": "-74.07764",
    "tier": 1
  },
  {
    "name": "Paterson",
    "countryCode": "US",
    "stateCode": "NJ",
    "population": 147754,
    "latitude": "40.91677",
    "longitude": "-74.17181",
    "tier": 1
  },
  {
    "name": "Charleston",
    "countryCode": "US",
    "stateCode": "WV",
    "population": 49736,
    "latitude": "38.34982",
    "longitude": "-81.63262",
    "tier": 1
  },
  {
    "name": "Huntington",
    "countryCode": "US",
    "stateCode": "WV",
    "population": 48638,
    "latitude": "38.41925",
    "longitude": "-82.44515",
    "tier": 1
  },
  {
    "name": "Parkersburg",
    "countryCode": "US",
    "stateCode": "WV",
    "population": 30991,
    "latitude": "39.26674",
    "longitude": "-81.56151",
    "tier": 1
  },
  {
    "name": "Portland",
    "countryCode": "US",
    "stateCode": "ME",
    "population": 66881,
    "latitude": "43.65737",
    "longitude": "-70.2589",
    "tier": 1
  },
  {
    "name": "Lewiston",
    "countryCode": "US",
    "stateCode": "ME",
    "population": 36202,
    "latitude": "44.10035",
    "longitude": "-70.21478",
    "tier": 1
  },
  {
    "name": "Bangor",
    "countryCode": "US",
    "stateCode": "ME",
    "population": 32391,
    "latitude": "44.80118",
    "longitude": "-68.77781",
    "tier": 1
  },
  {
    "name": "Sioux Falls",
    "countryCode": "US",
    "stateCode": "SD",
    "population": 171544,
    "latitude": "43.54997",
    "longitude": "-96.70033",
    "tier": 1
  },
  {
    "name": "Rapid City",
    "countryCode": "US",
    "stateCode": "SD",
    "population": 73569,
    "latitude": "44.08054",
    "longitude": "-103.23101",
    "tier": 1
  },
  {
    "name": "Aberdeen",
    "countryCode": "US",
    "stateCode": "SD",
    "population": 28102,
    "latitude": "45.4647",
    "longitude": "-98.48648",
    "tier": 1
  },
  {
    "name": "Des Moines",
    "countryCode": "US",
    "stateCode": "IA",
    "population": 210330,
    "latitude": "41.60054",
    "longitude": "-93.60911",
    "tier": 1
  },
  {
    "name": "Cedar Rapids",
    "countryCode": "US",
    "stateCode": "IA",
    "population": 130405,
    "latitude": "42.00833",
    "longitude": "-91.64407",
    "tier": 1
  },
  {
    "name": "Davenport",
    "countryCode": "US",
    "stateCode": "IA",
    "population": 102582,
    "latitude": "41.52364",
    "longitude": "-90.57764",
    "tier": 1
  },
  {
    "name": "Fargo",
    "countryCode": "US",
    "stateCode": "ND",
    "population": 118523,
    "latitude": "46.87719",
    "longitude": "-96.7898",
    "tier": 1
  },
  {
    "name": "Bismarck",
    "countryCode": "US",
    "stateCode": "ND",
    "population": 71167,
    "latitude": "46.80833",
    "longitude": "-100.78374",
    "tier": 1
  },
  {
    "name": "Grand Forks",
    "countryCode": "US",
    "stateCode": "ND",
    "population": 57011,
    "latitude": "47.92526",
    "longitude": "-97.03285",
    "tier": 1
  },
  {
    "name": "Omaha",
    "countryCode": "US",
    "stateCode": "NE",
    "population": 443885,
    "latitude": "41.25626",
    "longitude": "-95.94043",
    "tier": 1
  },
  {
    "name": "Lincoln",
    "countryCode": "US",
    "stateCode": "NE",
    "population": 277348,
    "latitude": "40.8",
    "longitude": "-96.66696",
    "tier": 1
  },
  {
    "name": "Bellevue",
    "countryCode": "US",
    "stateCode": "NE",
    "population": 55510,
    "latitude": "41.13667",
    "longitude": "-95.89084",
    "tier": 1
  },
  {
    "name": "Manchester",
    "countryCode": "US",
    "stateCode": "NH",
    "population": 110229,
    "latitude": "42.99564",
    "longitude": "-71.45479",
    "tier": 1
  },
  {
    "name": "Nashua",
    "countryCode": "US",
    "stateCode": "NH",
    "population": 87970,
    "latitude": "42.76537",
    "longitude": "-71.46757",
    "tier": 1
  },
  {
    "name": "Concord",
    "countryCode": "US",
    "stateCode": "NH",
    "population": 42620,
    "latitude": "43.20814",
    "longitude": "-71.53757",
    "tier": 1
  },
  {
    "name": "Providence",
    "countryCode": "US",
    "stateCode": "RI",
    "population": 179207,
    "latitude": "41.82399",
    "longitude": "-71.41283",
    "tier": 1
  },
  {
    "name": "Warwick",
    "countryCode": "US",
    "stateCode": "RI",
    "population": 81699,
    "latitude": "41.7001",
    "longitude": "-71.41617",
    "tier": 1
  },
  {
    "name": "Cranston",
    "countryCode": "US",
    "stateCode": "RI",
    "population": 81073,
    "latitude": "41.77982",
    "longitude": "-71.43728",
    "tier": 1
  },
  {
    "name": "Burlington",
    "countryCode": "US",
    "stateCode": "VT",
    "population": 42452,
    "latitude": "44.47588",
    "longitude": "-73.21207",
    "tier": 1
  },
  {
    "name": "South Burlington",
    "countryCode": "US",
    "stateCode": "VT",
    "population": 18791,
    "latitude": "44.46699",
    "longitude": "-73.17096",
    "tier": 1
  },
  {
    "name": "Colchester",
    "countryCode": "US",
    "stateCode": "VT",
    "population": 16986,
    "latitude": "44.54394",
    "longitude": "-73.14791",
    "tier": 1
  },
  {
    "name": "Boise",
    "countryCode": "US",
    "stateCode": "ID",
    "population": 145987,
    "latitude": "43.6135",
    "longitude": "-116.20345",
    "tier": 1
  },
  {
    "name": "Meridian",
    "countryCode": "US",
    "stateCode": "ID",
    "population": 90739,
    "latitude": "43.61211",
    "longitude": "-116.39151",
    "tier": 1
  },
  {
    "name": "Nampa",
    "countryCode": "US",
    "stateCode": "ID",
    "population": 89839,
    "latitude": "43.54072",
    "longitude": "-116.56346",
    "tier": 1
  },
  {
    "name": "Anchorage",
    "countryCode": "US",
    "stateCode": "AK",
    "population": 298695,
    "latitude": "61.21806",
    "longitude": "-149.90028",
    "tier": 1
  },
  {
    "name": "Juneau",
    "countryCode": "US",
    "stateCode": "AK",
    "population": 32756,
    "latitude": "58.30194",
    "longitude": "-134.41972",
    "tier": 1
  },
  {
    "name": "Fairbanks",
    "countryCode": "US",
    "stateCode": "AK",
    "population": 32325,
    "latitude": "64.83778",
    "longitude": "-147.71639",
    "tier": 1
  },
  {
    "name": "Billings",
    "countryCode": "US",
    "stateCode": "MT",
    "population": 110263,
    "latitude": "45.78329",
    "longitude": "-108.50069",
    "tier": 1
  },
  {
    "name": "Missoula",
    "countryCode": "US",
    "stateCode": "MT",
    "population": 71022,
    "latitude": "46.87215",
    "longitude": "-113.994",
    "tier": 1
  },
  {
    "name": "Great Falls",
    "countryCode": "US",
    "stateCode": "MT",
    "population": 59638,
    "latitude": "47.50024",
    "longitude": "-111.30081",
    "tier": 1
  },
  {
    "name": "Cheyenne",
    "countryCode": "US",
    "stateCode": "WY",
    "population": 63335,
    "latitude": "41.13998",
    "longitude": "-104.82025",
    "tier": 1
  },
  {
    "name": "Casper",
    "countryCode": "US",
    "stateCode": "WY",
    "population": 60285,
    "latitude": "42.86663",
    "longitude": "-106.31308",
    "tier": 1
  },
  {
    "name": "Gillette",
    "countryCode": "US",
    "stateCode": "WY",
    "population": 32649,
    "latitude": "44.29109",
    "longitude": "-105.50222",
    "tier": 1
  },
  {
    "name": "Honolulu",
    "countryCode": "US",
    "stateCode": "HI",
    "population": 371657,
    "latitude": "21.30694",
    "longitude": "-157.85833",
    "tier": 1
  },
  {
    "name": "East Honolulu",
    "countryCode": "US",
    "stateCode": "HI",
    "population": 49914,
    "latitude": "21.28906",
    "longitude": "-157.71734",
    "tier": 1
  },
  {
    "name": "Pearl City",
    "countryCode": "US",
    "stateCode": "HI",
    "population": 47698,
    "latitude": "21.39734",
    "longitude": "-157.97516",
    "tier": 1
  },
  {
    "name": "Toronto",
    "countryCode": "CA",
    "stateCode": "ON",
    "population": 2600000,
    "latitude": "43.70011",
    "longitude": "-79.4163",
    "tier": 2
  },
  {
    "name": "Montréal",
    "countryCode": "CA",
    "stateCode": "QC",
    "population": 1600000,
    "latitude": "45.50884",
    "longitude": "-73.58781",
    "tier": 2
  },
  {
    "name": "Calgary",
    "countryCode": "CA",
    "stateCode": "AB",
    "population": 1019942,
    "latitude": "51.05011",
    "longitude": "-114.08529",
    "tier": 2
  },
  {
    "name": "Ottawa",
    "countryCode": "CA",
    "stateCode": "ON",
    "population": 812129,
    "latitude": "45.41117",
    "longitude": "-75.69812",
    "tier": 2
  },
  {
    "name": "Edmonton",
    "countryCode": "CA",
    "stateCode": "AB",
    "population": 712391,
    "latitude": "53.55014",
    "longitude": "-113.46871",
    "tier": 2
  },
  {
    "name": "Mississauga",
    "countryCode": "CA",
    "stateCode": "ON",
    "population": 668549,
    "latitude": "43.5789",
    "longitude": "-79.6583",
    "tier": 2
  },
  {
    "name": "North York",
    "countryCode": "CA",
    "stateCode": "ON",
    "population": 636000,
    "latitude": "43.76681",
    "longitude": "-79.4163",
    "tier": 2
  },
  {
    "name": "Winnipeg",
    "countryCode": "CA",
    "stateCode": "MB",
    "population": 632063,
    "latitude": "49.8844",
    "longitude": "-97.14704",
    "tier": 2
  },
  {
    "name": "Vancouver",
    "countryCode": "CA",
    "stateCode": "BC",
    "population": 600000,
    "latitude": "49.24966",
    "longitude": "-123.11934",
    "tier": 2
  },
  {
    "name": "Scarborough",
    "countryCode": "CA",
    "stateCode": "ON",
    "population": 600000,
    "latitude": "43.77223",
    "longitude": "-79.25666",
    "tier": 2
  },
  {
    "name": "Québec",
    "countryCode": "CA",
    "stateCode": "QC",
    "population": 528595,
    "latitude": "46.81228",
    "longitude": "-71.21454",
    "tier": 2
  },
  {
    "name": "Hamilton",
    "countryCode": "CA",
    "stateCode": "ON",
    "population": 519949,
    "latitude": "43.25011",
    "longitude": "-79.84963",
    "tier": 2
  },
  {
    "name": "Brampton",
    "countryCode": "CA",
    "stateCode": "ON",
    "population": 433806,
    "latitude": "43.68341",
    "longitude": "-79.76633",
    "tier": 2
  },
  {
    "name": "Surrey",
    "countryCode": "CA",
    "stateCode": "BC",
    "population": 394976,
    "latitude": "49.10635",
    "longitude": "-122.82509",
    "tier": 2
  },
  {
    "name": "Laval",
    "countryCode": "CA",
    "stateCode": "QC",
    "population": 376845,
    "latitude": "45.56995",
    "longitude": "-73.692",
    "tier": 2
  },
  {
    "name": "London",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 7556900,
    "latitude": "51.50853",
    "longitude": "-0.12574",
    "tier": 2
  },
  {
    "name": "Birmingham",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 984333,
    "latitude": "52.48142",
    "longitude": "-1.89983",
    "tier": 2
  },
  {
    "name": "Liverpool",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 864122,
    "latitude": "53.41058",
    "longitude": "-2.97794",
    "tier": 2
  },
  {
    "name": "Nottingham",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 729977,
    "latitude": "52.9536",
    "longitude": "-1.15047",
    "tier": 2
  },
  {
    "name": "Sheffield",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 685368,
    "latitude": "53.38297",
    "longitude": "-1.4659",
    "tier": 2
  },
  {
    "name": "Bristol",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 617280,
    "latitude": "51.45523",
    "longitude": "-2.59665",
    "tier": 2
  },
  {
    "name": "Glasgow",
    "countryCode": "GB",
    "stateCode": "SCT",
    "population": 591620,
    "latitude": "55.86515",
    "longitude": "-4.25763",
    "tier": 2
  },
  {
    "name": "Leicester",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 508916,
    "latitude": "52.6386",
    "longitude": "-1.13169",
    "tier": 2
  },
  {
    "name": "Edinburgh",
    "countryCode": "GB",
    "stateCode": "SCT",
    "population": 464990,
    "latitude": "55.95206",
    "longitude": "-3.19648",
    "tier": 2
  },
  {
    "name": "Leeds",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 455123,
    "latitude": "53.79648",
    "longitude": "-1.54785",
    "tier": 2
  },
  {
    "name": "Cardiff",
    "countryCode": "GB",
    "stateCode": "WLS",
    "population": 447287,
    "latitude": "51.48",
    "longitude": "-3.18",
    "tier": 2
  },
  {
    "name": "Manchester",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 395515,
    "latitude": "53.48095",
    "longitude": "-2.23743",
    "tier": 2
  },
  {
    "name": "Stoke-on-Trent",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 372775,
    "latitude": "53.00415",
    "longitude": "-2.18538",
    "tier": 2
  },
  {
    "name": "Coventry",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 359262,
    "latitude": "52.40656",
    "longitude": "-1.51217",
    "tier": 2
  },
  {
    "name": "Sunderland",
    "countryCode": "GB",
    "stateCode": "ENG",
    "population": 335415,
    "latitude": "54.90465",
    "longitude": "-1.38222",
    "tier": 2
  },
  {
    "name": "Sydney",
    "countryCode": "AU",
    "stateCode": "02",
    "population": 4627345,
    "latitude": "-33.86785",
    "longitude": "151.20732",
    "tier": 2
  },
  {
    "name": "Melbourne",
    "countryCode": "AU",
    "stateCode": "07",
    "population": 4246375,
    "latitude": "-37.814",
    "longitude": "144.96332",
    "tier": 2
  },
  {
    "name": "Brisbane",
    "countryCode": "AU",
    "stateCode": "04",
    "population": 2189878,
    "latitude": "-27.46794",
    "longitude": "153.02809",
    "tier": 2
  },
  {
    "name": "Perth",
    "countryCode": "AU",
    "stateCode": "08",
    "population": 1896548,
    "latitude": "-31.95224",
    "longitude": "115.8614",
    "tier": 2
  },
  {
    "name": "Adelaide",
    "countryCode": "AU",
    "stateCode": "05",
    "population": 1225235,
    "latitude": "-34.92866",
    "longitude": "138.59863",
    "tier": 2
  },
  {
    "name": "Gold Coast",
    "countryCode": "AU",
    "stateCode": "04",
    "population": 591473,
    "latitude": "-28.00029",
    "longitude": "153.43088",
    "tier": 2
  },
  {
    "name": "Canberra",
    "countryCode": "AU",
    "stateCode": "01",
    "population": 367752,
    "latitude": "-35.28346",
    "longitude": "149.12807",
    "tier": 2
  },
  {
    "name": "Newcastle",
    "countryCode": "AU",
    "stateCode": "02",
    "population": 308308,
    "latitude": "-32.92953",
    "longitude": "151.7801",
    "tier": 2
  },
  {
    "name": "Wollongong",
    "countryCode": "AU",
    "stateCode": "02",
    "population": 292190,
    "latitude": "-34.424",
    "longitude": "150.89345",
    "tier": 2
  },
  {
    "name": "Logan City",
    "countryCode": "AU",
    "stateCode": "04",
    "population": 282673,
    "latitude": "-27.63917",
    "longitude": "153.10944",
    "tier": 2
  },
  {
    "name": "Geelong",
    "countryCode": "AU",
    "stateCode": "07",
    "population": 226034,
    "latitude": "-38.14711",
    "longitude": "144.36069",
    "tier": 2
  },
  {
    "name": "Hobart",
    "countryCode": "AU",
    "stateCode": "06",
    "population": 216656,
    "latitude": "-42.87936",
    "longitude": "147.32941",
    "tier": 2
  },
  {
    "name": "Townsville",
    "countryCode": "AU",
    "stateCode": "04",
    "population": 196219,
    "latitude": "-19.26639",
    "longitude": "146.80569",
    "tier": 2
  },
  {
    "name": "Cairns",
    "countryCode": "AU",
    "stateCode": "04",
    "population": 153075,
    "latitude": "-16.92366",
    "longitude": "145.76613",
    "tier": 2
  },
  {
    "name": "Toowoomba",
    "countryCode": "AU",
    "stateCode": "04",
    "population": 131258,
    "latitude": "-27.56056",
    "longitude": "151.95386",
    "tier": 2
  },
  {
    "name": "Dublin",
    "countryCode": "IE",
    "stateCode": "L",
    "population": 1024027,
    "latitude": "53.33306",
    "longitude": "-6.24889",
    "tier": 2
  },
  {
    "name": "Cork",
    "countryCode": "IE",
    "stateCode": "M",
    "population": 190384,
    "latitude": "51.89797",
    "longitude": "-8.47061",
    "tier": 2
  },
  {
    "name": "Luimneach",
    "countryCode": "IE",
    "stateCode": "M",
    "population": 90054,
    "latitude": "52.66472",
    "longitude": "-8.62306",
    "tier": 2
  },
  {
    "name": "Gaillimh",
    "countryCode": "IE",
    "stateCode": "C",
    "population": 70686,
    "latitude": "53.27245",
    "longitude": "-9.05095",
    "tier": 2
  },
  {
    "name": "Tallaght",
    "countryCode": "IE",
    "stateCode": "L",
    "population": 64282,
    "latitude": "53.2859",
    "longitude": "-6.37344",
    "tier": 2
  },
  {
    "name": "Waterford",
    "countryCode": "IE",
    "stateCode": "M",
    "population": 47904,
    "latitude": "52.25833",
    "longitude": "-7.11194",
    "tier": 2
  },
  {
    "name": "Swords",
    "countryCode": "IE",
    "stateCode": "L",
    "population": 36924,
    "latitude": "53.45972",
    "longitude": "-6.21806",
    "tier": 2
  },
  {
    "name": "Drogheda",
    "countryCode": "IE",
    "stateCode": "L",
    "population": 33441,
    "latitude": "53.71889",
    "longitude": "-6.34778",
    "tier": 2
  },
  {
    "name": "Dundalk",
    "countryCode": "IE",
    "stateCode": "L",
    "population": 33428,
    "latitude": "54",
    "longitude": "-6.41667",
    "tier": 2
  },
  {
    "name": "Bray",
    "countryCode": "IE",
    "stateCode": "L",
    "population": 32600,
    "latitude": "53.20278",
    "longitude": "-6.09833",
    "tier": 2
  },
  {
    "name": "Dún Laoghaire",
    "countryCode": "IE",
    "stateCode": "L",
    "population": 26525,
    "latitude": "53.29395",
    "longitude": "-6.13586",
    "tier": 2
  },
  {
    "name": "Navan",
    "countryCode": "IE",
    "stateCode": "L",
    "population": 24545,
    "latitude": "53.65278",
    "longitude": "-6.68139",
    "tier": 2
  },
  {
    "name": "Ennis",
    "countryCode": "IE",
    "stateCode": "M",
    "population": 24427,
    "latitude": "52.84361",
    "longitude": "-8.98639",
    "tier": 2
  },
  {
    "name": "Balbriggan",
    "countryCode": "IE",
    "stateCode": "L",
    "population": 23364,
    "latitude": "53.60846",
    "longitude": "-6.1831",
    "tier": 2
  },
  {
    "name": "Tralee",
    "countryCode": "IE",
    "stateCode": "M",
    "population": 22941,
    "latitude": "52.27042",
    "longitude": "-9.70264",
    "tier": 2
  },
  {
    "name": "Auckland",
    "countryCode": "NZ",
    "stateCode": "E7",
    "population": 417910,
    "latitude": "-36.84853",
    "longitude": "174.76349",
    "tier": 2
  },
  {
    "name": "Wellington",
    "countryCode": "NZ",
    "stateCode": "G2",
    "population": 381900,
    "latitude": "-41.28664",
    "longitude": "174.77557",
    "tier": 2
  },
  {
    "name": "Christchurch",
    "countryCode": "NZ",
    "stateCode": "E9",
    "population": 363926,
    "latitude": "-43.53333",
    "longitude": "172.63333",
    "tier": 2
  },
  {
    "name": "Manukau City",
    "countryCode": "NZ",
    "stateCode": "E7",
    "population": 362000,
    "latitude": "-36.99282",
    "longitude": "174.87986",
    "tier": 2
  },
  {
    "name": "North Shore",
    "countryCode": "NZ",
    "stateCode": "E7",
    "population": 207865,
    "latitude": "-36.8",
    "longitude": "174.75",
    "tier": 2
  },
  {
    "name": "Hamilton",
    "countryCode": "NZ",
    "stateCode": "G1",
    "population": 152641,
    "latitude": "-37.78333",
    "longitude": "175.28333",
    "tier": 2
  },
  {
    "name": "Dunedin",
    "countryCode": "NZ",
    "stateCode": "F7",
    "population": 114347,
    "latitude": "-45.87416",
    "longitude": "170.50361",
    "tier": 2
  },
  {
    "name": "Tauranga",
    "countryCode": "NZ",
    "stateCode": "E8",
    "population": 110338,
    "latitude": "-37.68611",
    "longitude": "176.16667",
    "tier": 2
  },
  {
    "name": "Lower Hutt",
    "countryCode": "NZ",
    "stateCode": "G2",
    "population": 101194,
    "latitude": "-41.21667",
    "longitude": "174.91667",
    "tier": 2
  },
  {
    "name": "Palmerston North",
    "countryCode": "NZ",
    "stateCode": "F3",
    "population": 75996,
    "latitude": "-40.35636",
    "longitude": "175.61113",
    "tier": 2
  },
  {
    "name": "Rotorua",
    "countryCode": "NZ",
    "stateCode": "E8",
    "population": 65901,
    "latitude": "-38.13874",
    "longitude": "176.24516",
    "tier": 2
  },
  {
    "name": "Hastings",
    "countryCode": "NZ",
    "stateCode": "F2",
    "population": 61696,
    "latitude": "-39.6381",
    "longitude": "176.84918",
    "tier": 2
  },
  {
    "name": "Nelson",
    "countryCode": "NZ",
    "stateCode": "F5",
    "population": 59200,
    "latitude": "-41.27078",
    "longitude": "173.28404",
    "tier": 2
  },
  {
    "name": "Napier",
    "countryCode": "NZ",
    "stateCode": "F2",
    "population": 56787,
    "latitude": "-39.4926",
    "longitude": "176.91233",
    "tier": 2
  },
  {
    "name": "Mangere",
    "countryCode": "NZ",
    "stateCode": "E7",
    "population": 55266,
    "latitude": "-36.96807",
    "longitude": "174.79875",
    "tier": 2
  },
  {
    "name": "Lisbon",
    "countryCode": "PT",
    "stateCode": "14",
    "population": 517802,
    "latitude": "38.71667",
    "longitude": "-9.13333",
    "tier": 2
  },
  {
    "name": "Porto",
    "countryCode": "PT",
    "stateCode": "17",
    "population": 249633,
    "latitude": "41.14961",
    "longitude": "-8.61099",
    "tier": 2
  },
  {
    "name": "Amadora",
    "countryCode": "PT",
    "stateCode": "14",
    "population": 178858,
    "latitude": "38.75382",
    "longitude": "-9.23083",
    "tier": 2
  },
  {
    "name": "Braga",
    "countryCode": "PT",
    "stateCode": "04",
    "population": 121394,
    "latitude": "41.55032",
    "longitude": "-8.42005",
    "tier": 2
  },
  {
    "name": "Setúbal",
    "countryCode": "PT",
    "stateCode": "19",
    "population": 117110,
    "latitude": "38.5244",
    "longitude": "-8.8882",
    "tier": 2
  },
  {
    "name": "Coimbra",
    "countryCode": "PT",
    "stateCode": "07",
    "population": 106582,
    "latitude": "40.20564",
    "longitude": "-8.41955",
    "tier": 2
  },
  {
    "name": "Queluz",
    "countryCode": "PT",
    "stateCode": "14",
    "population": 103399,
    "latitude": "38.75657",
    "longitude": "-9.25451",
    "tier": 2
  },
  {
    "name": "Funchal",
    "countryCode": "PT",
    "stateCode": "10",
    "population": 100847,
    "latitude": "32.66568",
    "longitude": "-16.92547",
    "tier": 2
  },
  {
    "name": "Cacém",
    "countryCode": "PT",
    "stateCode": "14",
    "population": 93982,
    "latitude": "38.76698",
    "longitude": "-9.29793",
    "tier": 2
  },
  {
    "name": "Vila Nova de Gaia",
    "countryCode": "PT",
    "stateCode": "17",
    "population": 70811,
    "latitude": "41.12401",
    "longitude": "-8.61241",
    "tier": 2
  },
  {
    "name": "Algueirão",
    "countryCode": "PT",
    "stateCode": "14",
    "population": 66250,
    "latitude": "38.79764",
    "longitude": "-9.3437",
    "tier": 2
  },
  {
    "name": "Loures",
    "countryCode": "PT",
    "stateCode": "14",
    "population": 66231,
    "latitude": "38.83091",
    "longitude": "-9.16845",
    "tier": 2
  },
  {
    "name": "Felgueiras",
    "countryCode": "PT",
    "stateCode": "17",
    "population": 58065,
    "latitude": "41.36806",
    "longitude": "-8.19396",
    "tier": 2
  },
  {
    "name": "Évora",
    "countryCode": "PT",
    "stateCode": "08",
    "population": 55620,
    "latitude": "38.56667",
    "longitude": "-7.9",
    "tier": 2
  },
  {
    "name": "Rio de Mouro",
    "countryCode": "PT",
    "stateCode": "14",
    "population": 54695,
    "latitude": "38.76613",
    "longitude": "-9.32804",
    "tier": 2
  },
  {
    "name": "São Paulo",
    "countryCode": "BR",
    "stateCode": "27",
    "population": 10021295,
    "latitude": "-23.5475",
    "longitude": "-46.63611",
    "tier": 2
  },
  {
    "name": "Rio de Janeiro",
    "countryCode": "BR",
    "stateCode": "21",
    "population": 6023699,
    "latitude": "-22.90642",
    "longitude": "-43.18223",
    "tier": 2
  },
  {
    "name": "Salvador",
    "countryCode": "BR",
    "stateCode": "05",
    "population": 2711840,
    "latitude": "-12.97111",
    "longitude": "-38.51083",
    "tier": 2
  },
  {
    "name": "Fortaleza",
    "countryCode": "BR",
    "stateCode": "06",
    "population": 2400000,
    "latitude": "-3.71722",
    "longitude": "-38.54306",
    "tier": 2
  },
  {
    "name": "Belo Horizonte",
    "countryCode": "BR",
    "stateCode": "15",
    "population": 2373224,
    "latitude": "-19.92083",
    "longitude": "-43.93778",
    "tier": 2
  },
  {
    "name": "Brasília",
    "countryCode": "BR",
    "stateCode": "07",
    "population": 2207718,
    "latitude": "-15.77972",
    "longitude": "-47.92972",
    "tier": 2
  },
  {
    "name": "Curitiba",
    "countryCode": "BR",
    "stateCode": "18",
    "population": 1718421,
    "latitude": "-25.42778",
    "longitude": "-49.27306",
    "tier": 2
  },
  {
    "name": "Manaus",
    "countryCode": "BR",
    "stateCode": "04",
    "population": 1598210,
    "latitude": "-3.10194",
    "longitude": "-60.025",
    "tier": 2
  },
  {
    "name": "Recife",
    "countryCode": "BR",
    "stateCode": "30",
    "population": 1478098,
    "latitude": "-8.05389",
    "longitude": "-34.88111",
    "tier": 2
  },
  {
    "name": "Belém",
    "countryCode": "BR",
    "stateCode": "16",
    "population": 1407737,
    "latitude": "-1.45583",
    "longitude": "-48.50444",
    "tier": 2
  },
  {
    "name": "Porto Alegre",
    "countryCode": "BR",
    "stateCode": "23",
    "population": 1372741,
    "latitude": "-30.03283",
    "longitude": "-51.23019",
    "tier": 2
  },
  {
    "name": "Goiânia",
    "countryCode": "BR",
    "stateCode": "29",
    "population": 1171195,
    "latitude": "-16.67861",
    "longitude": "-49.25389",
    "tier": 2
  },
  {
    "name": "Guarulhos",
    "countryCode": "BR",
    "stateCode": "27",
    "population": 1169577,
    "latitude": "-23.46278",
    "longitude": "-46.53333",
    "tier": 2
  },
  {
    "name": "Campinas",
    "countryCode": "BR",
    "stateCode": "27",
    "population": 1031554,
    "latitude": "-22.90556",
    "longitude": "-47.06083",
    "tier": 2
  },
  {
    "name": "Nova Iguaçu",
    "countryCode": "BR",
    "stateCode": "21",
    "population": 1002118,
    "latitude": "-22.75917",
    "longitude": "-43.45111",
    "tier": 2
  },
  {
    "name": "Paris",
    "countryCode": "FR",
    "stateCode": "11",
    "population": 2138551,
    "latitude": "48.85341",
    "longitude": "2.3488",
    "tier": 2
  },
  {
    "name": "Marseille",
    "countryCode": "FR",
    "stateCode": "93",
    "population": 794811,
    "latitude": "43.29695",
    "longitude": "5.38107",
    "tier": 2
  },
  {
    "name": "Lyon",
    "countryCode": "FR",
    "stateCode": "84",
    "population": 472317,
    "latitude": "45.74846",
    "longitude": "4.84671",
    "tier": 2
  },
  {
    "name": "Toulouse",
    "countryCode": "FR",
    "stateCode": "76",
    "population": 433055,
    "latitude": "43.60426",
    "longitude": "1.44367",
    "tier": 2
  },
  {
    "name": "Nice",
    "countryCode": "FR",
    "stateCode": "93",
    "population": 338620,
    "latitude": "43.70313",
    "longitude": "7.26608",
    "tier": 2
  },
  {
    "name": "Nantes",
    "countryCode": "FR",
    "stateCode": "52",
    "population": 277269,
    "latitude": "47.21725",
    "longitude": "-1.55336",
    "tier": 2
  },
  {
    "name": "Strasbourg",
    "countryCode": "FR",
    "stateCode": "44",
    "population": 274845,
    "latitude": "48.58392",
    "longitude": "7.74553",
    "tier": 2
  },
  {
    "name": "Montpellier",
    "countryCode": "FR",
    "stateCode": "76",
    "population": 248252,
    "latitude": "43.61092",
    "longitude": "3.87723",
    "tier": 2
  },
  {
    "name": "Bordeaux",
    "countryCode": "FR",
    "stateCode": "75",
    "population": 231844,
    "latitude": "44.84044",
    "longitude": "-0.5805",
    "tier": 2
  },
  {
    "name": "Lille",
    "countryCode": "FR",
    "stateCode": "32",
    "population": 228328,
    "latitude": "50.63297",
    "longitude": "3.05858",
    "tier": 2
  },
  {
    "name": "Rennes",
    "countryCode": "FR",
    "stateCode": "53",
    "population": 209375,
    "latitude": "48.11198",
    "longitude": "-1.67429",
    "tier": 2
  },
  {
    "name": "Reims",
    "countryCode": "FR",
    "stateCode": "44",
    "population": 196565,
    "latitude": "49.26526",
    "longitude": "4.02853",
    "tier": 2
  },
  {
    "name": "Le Havre",
    "countryCode": "FR",
    "stateCode": "28",
    "population": 185972,
    "latitude": "49.4938",
    "longitude": "0.10767",
    "tier": 2
  },
  {
    "name": "Cergy-Pontoise",
    "countryCode": "FR",
    "stateCode": "11",
    "population": 183430,
    "latitude": "49.03894",
    "longitude": "2.07805",
    "tier": 2
  },
  {
    "name": "Saint-Étienne",
    "countryCode": "FR",
    "stateCode": "84",
    "population": 176280,
    "latitude": "45.43389",
    "longitude": "4.39",
    "tier": 2
  },
  {
    "name": "Madrid",
    "countryCode": "ES",
    "stateCode": "29",
    "population": 3255944,
    "latitude": "40.4165",
    "longitude": "-3.70256",
    "tier": 2
  },
  {
    "name": "Barcelona",
    "countryCode": "ES",
    "stateCode": "56",
    "population": 1621537,
    "latitude": "41.38879",
    "longitude": "2.15899",
    "tier": 2
  },
  {
    "name": "Valencia",
    "countryCode": "ES",
    "stateCode": "60",
    "population": 814208,
    "latitude": "39.46975",
    "longitude": "-0.37739",
    "tier": 2
  },
  {
    "name": "Sevilla",
    "countryCode": "ES",
    "stateCode": "51",
    "population": 703206,
    "latitude": "37.38283",
    "longitude": "-5.97317",
    "tier": 2
  },
  {
    "name": "Zaragoza",
    "countryCode": "ES",
    "stateCode": "52",
    "population": 674317,
    "latitude": "41.65606",
    "longitude": "-0.87734",
    "tier": 2
  },
  {
    "name": "Málaga",
    "countryCode": "ES",
    "stateCode": "51",
    "population": 568305,
    "latitude": "36.72016",
    "longitude": "-4.42034",
    "tier": 2
  },
  {
    "name": "Murcia",
    "countryCode": "ES",
    "stateCode": "31",
    "population": 436870,
    "latitude": "37.98704",
    "longitude": "-1.13004",
    "tier": 2
  },
  {
    "name": "Palma",
    "countryCode": "ES",
    "stateCode": "07",
    "population": 401270,
    "latitude": "39.56939",
    "longitude": "2.65024",
    "tier": 2
  },
  {
    "name": "Las Palmas de Gran Canaria",
    "countryCode": "ES",
    "stateCode": "53",
    "population": 381847,
    "latitude": "28.09973",
    "longitude": "-15.41343",
    "tier": 2
  },
  {
    "name": "Bilbao",
    "countryCode": "ES",
    "stateCode": "59",
    "population": 354860,
    "latitude": "43.26271",
    "longitude": "-2.92528",
    "tier": 2
  },
  {
    "name": "Alicante",
    "countryCode": "ES",
    "stateCode": "60",
    "population": 334757,
    "latitude": "38.34517",
    "longitude": "-0.48149",
    "tier": 2
  },
  {
    "name": "Córdoba",
    "countryCode": "ES",
    "stateCode": "51",
    "population": 328428,
    "latitude": "37.89155",
    "longitude": "-4.77275",
    "tier": 2
  },
  {
    "name": "Valladolid",
    "countryCode": "ES",
    "stateCode": "55",
    "population": 317864,
    "latitude": "41.65518",
    "longitude": "-4.72372",
    "tier": 2
  },
  {
    "name": "Vigo",
    "countryCode": "ES",
    "stateCode": "58",
    "population": 297332,
    "latitude": "42.23282",
    "longitude": "-8.72264",
    "tier": 2
  },
  {
    "name": "Gijón",
    "countryCode": "ES",
    "stateCode": "34",
    "population": 277554,
    "latitude": "43.53573",
    "longitude": "-5.66152",
    "tier": 2
  },
  {
    "name": "Amsterdam",
    "countryCode": "NL",
    "stateCode": "07",
    "population": 741636,
    "latitude": "52.37403",
    "longitude": "4.88969",
    "tier": 2
  },
  {
    "name": "Rotterdam",
    "countryCode": "NL",
    "stateCode": "11",
    "population": 598199,
    "latitude": "51.9225",
    "longitude": "4.47917",
    "tier": 2
  },
  {
    "name": "The Hague",
    "countryCode": "NL",
    "stateCode": "11",
    "population": 474292,
    "latitude": "52.07667",
    "longitude": "4.29861",
    "tier": 2
  },
  {
    "name": "Utrecht",
    "countryCode": "NL",
    "stateCode": "09",
    "population": 290529,
    "latitude": "52.09083",
    "longitude": "5.12222",
    "tier": 2
  },
  {
    "name": "Eindhoven",
    "countryCode": "NL",
    "stateCode": "06",
    "population": 209620,
    "latitude": "51.44083",
    "longitude": "5.47778",
    "tier": 2
  },
  {
    "name": "Tilburg",
    "countryCode": "NL",
    "stateCode": "06",
    "population": 199613,
    "latitude": "51.55551",
    "longitude": "5.0913",
    "tier": 2
  },
  {
    "name": "Groningen",
    "countryCode": "NL",
    "stateCode": "04",
    "population": 181194,
    "latitude": "53.21917",
    "longitude": "6.56667",
    "tier": 2
  },
  {
    "name": "Almere Stad",
    "countryCode": "NL",
    "stateCode": "16",
    "population": 176432,
    "latitude": "52.37025",
    "longitude": "5.21413",
    "tier": 2
  },
  {
    "name": "Breda",
    "countryCode": "NL",
    "stateCode": "06",
    "population": 167673,
    "latitude": "51.58656",
    "longitude": "4.77596",
    "tier": 2
  },
  {
    "name": "Nijmegen",
    "countryCode": "NL",
    "stateCode": "03",
    "population": 158732,
    "latitude": "51.8425",
    "longitude": "5.85278",
    "tier": 2
  },
  {
    "name": "Enschede",
    "countryCode": "NL",
    "stateCode": "15",
    "population": 153655,
    "latitude": "52.21833",
    "longitude": "6.89583",
    "tier": 2
  },
  {
    "name": "Haarlem",
    "countryCode": "NL",
    "stateCode": "07",
    "population": 147590,
    "latitude": "52.38084",
    "longitude": "4.63683",
    "tier": 2
  },
  {
    "name": "Arnhem",
    "countryCode": "NL",
    "stateCode": "03",
    "population": 141674,
    "latitude": "51.98",
    "longitude": "5.91111",
    "tier": 2
  },
  {
    "name": "Zaanstad",
    "countryCode": "NL",
    "stateCode": "07",
    "population": 140085,
    "latitude": "52.45313",
    "longitude": "4.81356",
    "tier": 2
  },
  {
    "name": "Amersfoort",
    "countryCode": "NL",
    "stateCode": "09",
    "population": 139914,
    "latitude": "52.155",
    "longitude": "5.3875",
    "tier": 2
  },
  {
    "name": "Berlin",
    "countryCode": "DE",
    "stateCode": "16",
    "population": 3426354,
    "latitude": "52.52437",
    "longitude": "13.41053",
    "tier": 2
  },
  {
    "name": "Hamburg",
    "countryCode": "DE",
    "stateCode": "04",
    "population": 1739117,
    "latitude": "53.55073",
    "longitude": "9.99302",
    "tier": 2
  },
  {
    "name": "Munich",
    "countryCode": "DE",
    "stateCode": "02",
    "population": 1260391,
    "latitude": "48.13743",
    "longitude": "11.57549",
    "tier": 2
  },
  {
    "name": "Köln",
    "countryCode": "DE",
    "stateCode": "07",
    "population": 963395,
    "latitude": "50.93333",
    "longitude": "6.95",
    "tier": 2
  },
  {
    "name": "Frankfurt am Main",
    "countryCode": "DE",
    "stateCode": "05",
    "population": 650000,
    "latitude": "50.11552",
    "longitude": "8.68417",
    "tier": 2
  },
  {
    "name": "Essen",
    "countryCode": "DE",
    "stateCode": "07",
    "population": 593085,
    "latitude": "51.45657",
    "longitude": "7.01228",
    "tier": 2
  },
  {
    "name": "Stuttgart",
    "countryCode": "DE",
    "stateCode": "01",
    "population": 589793,
    "latitude": "48.78232",
    "longitude": "9.17702",
    "tier": 2
  },
  {
    "name": "Dortmund",
    "countryCode": "DE",
    "stateCode": "07",
    "population": 588462,
    "latitude": "51.51494",
    "longitude": "7.466",
    "tier": 2
  },
  {
    "name": "Düsseldorf",
    "countryCode": "DE",
    "stateCode": "07",
    "population": 573057,
    "latitude": "51.22172",
    "longitude": "6.77616",
    "tier": 2
  },
  {
    "name": "Bremen",
    "countryCode": "DE",
    "stateCode": "03",
    "population": 546501,
    "latitude": "53.07582",
    "longitude": "8.80717",
    "tier": 2
  },
  {
    "name": "Hannover",
    "countryCode": "DE",
    "stateCode": "06",
    "population": 515140,
    "latitude": "52.37052",
    "longitude": "9.73322",
    "tier": 2
  },
  {
    "name": "Leipzig",
    "countryCode": "DE",
    "stateCode": "13",
    "population": 504971,
    "latitude": "51.33962",
    "longitude": "12.37129",
    "tier": 2
  },
  {
    "name": "Duisburg",
    "countryCode": "DE",
    "stateCode": "07",
    "population": 504358,
    "latitude": "51.43247",
    "longitude": "6.76516",
    "tier": 2
  },
  {
    "name": "Nürnberg",
    "countryCode": "DE",
    "stateCode": "02",
    "population": 499237,
    "latitude": "49.45421",
    "longitude": "11.07752",
    "tier": 2
  },
  {
    "name": "Dresden",
    "countryCode": "DE",
    "stateCode": "13",
    "population": 486854,
    "latitude": "51.05089",
    "longitude": "13.73832",
    "tier": 2
  },
  {
    "name": "Rome",
    "countryCode": "IT",
    "stateCode": "07",
    "population": 2318895,
    "latitude": "41.89193",
    "longitude": "12.51133",
    "tier": 3
  },
  {
    "name": "Milan",
    "countryCode": "IT",
    "stateCode": "09",
    "population": 1236837,
    "latitude": "45.46427",
    "longitude": "9.18951",
    "tier": 3
  },
  {
    "name": "Naples",
    "countryCode": "IT",
    "stateCode": "04",
    "population": 959470,
    "latitude": "40.85216",
    "longitude": "14.26811",
    "tier": 3
  },
  {
    "name": "Turin",
    "countryCode": "IT",
    "stateCode": "12",
    "population": 870456,
    "latitude": "45.07049",
    "longitude": "7.68682",
    "tier": 3
  },
  {
    "name": "Palermo",
    "countryCode": "IT",
    "stateCode": "15",
    "population": 648260,
    "latitude": "38.13205",
    "longitude": "13.33561",
    "tier": 3
  },
  {
    "name": "Genoa",
    "countryCode": "IT",
    "stateCode": "08",
    "population": 580223,
    "latitude": "44.40478",
    "longitude": "8.94439",
    "tier": 3
  },
  {
    "name": "Bologna",
    "countryCode": "IT",
    "stateCode": "05",
    "population": 366133,
    "latitude": "44.49381",
    "longitude": "11.33875",
    "tier": 3
  },
  {
    "name": "Florence",
    "countryCode": "IT",
    "stateCode": "16",
    "population": 349296,
    "latitude": "43.77925",
    "longitude": "11.24626",
    "tier": 3
  },
  {
    "name": "Stockholm",
    "countryCode": "SE",
    "stateCode": "26",
    "population": 1515017,
    "latitude": "59.32938",
    "longitude": "18.06871",
    "tier": 3
  },
  {
    "name": "Göteborg",
    "countryCode": "SE",
    "stateCode": "28",
    "population": 572799,
    "latitude": "57.70716",
    "longitude": "11.96679",
    "tier": 3
  },
  {
    "name": "Malmö",
    "countryCode": "SE",
    "stateCode": "27",
    "population": 301706,
    "latitude": "55.60587",
    "longitude": "13.00073",
    "tier": 3
  },
  {
    "name": "Uppsala",
    "countryCode": "SE",
    "stateCode": "21",
    "population": 149245,
    "latitude": "59.85882",
    "longitude": "17.63889",
    "tier": 3
  },
  {
    "name": "Sollentuna",
    "countryCode": "SE",
    "stateCode": "26",
    "population": 139606,
    "latitude": "59.42804",
    "longitude": "17.95093",
    "tier": 3
  },
  {
    "name": "Södermalm",
    "countryCode": "SE",
    "stateCode": "26",
    "population": 127323,
    "latitude": "59.31278",
    "longitude": "18.07577",
    "tier": 3
  },
  {
    "name": "Västerås",
    "countryCode": "SE",
    "stateCode": "25",
    "population": 117746,
    "latitude": "59.61617",
    "longitude": "16.55276",
    "tier": 3
  },
  {
    "name": "Örebro",
    "countryCode": "SE",
    "stateCode": "15",
    "population": 115765,
    "latitude": "59.27412",
    "longitude": "15.2066",
    "tier": 3
  },
  {
    "name": "Oslo",
    "countryCode": "NO",
    "stateCode": "12",
    "population": 580000,
    "latitude": "59.91273",
    "longitude": "10.74609",
    "tier": 3
  },
  {
    "name": "Bergen",
    "countryCode": "NO",
    "stateCode": "46",
    "population": 213585,
    "latitude": "60.39299",
    "longitude": "5.32415",
    "tier": 3
  },
  {
    "name": "Trondheim",
    "countryCode": "NO",
    "stateCode": "21",
    "population": 147139,
    "latitude": "63.43049",
    "longitude": "10.39506",
    "tier": 3
  },
  {
    "name": "Stavanger",
    "countryCode": "NO",
    "stateCode": "14",
    "population": 121610,
    "latitude": "58.97005",
    "longitude": "5.73332",
    "tier": 3
  },
  {
    "name": "Drammen",
    "countryCode": "NO",
    "stateCode": "30",
    "population": 90722,
    "latitude": "59.74389",
    "longitude": "10.20449",
    "tier": 3
  },
  {
    "name": "Fredrikstad",
    "countryCode": "NO",
    "stateCode": "30",
    "population": 72760,
    "latitude": "59.2181",
    "longitude": "10.9298",
    "tier": 3
  },
  {
    "name": "Kristiansand",
    "countryCode": "NO",
    "stateCode": "42",
    "population": 63814,
    "latitude": "58.14671",
    "longitude": "7.9956",
    "tier": 3
  },
  {
    "name": "Sandnes",
    "countryCode": "NO",
    "stateCode": "14",
    "population": 63032,
    "latitude": "58.85244",
    "longitude": "5.73521",
    "tier": 3
  },
  {
    "name": "Copenhagen",
    "countryCode": "DK",
    "stateCode": "17",
    "population": 1153615,
    "latitude": "55.67594",
    "longitude": "12.56553",
    "tier": 3
  },
  {
    "name": "Århus",
    "countryCode": "DK",
    "stateCode": "18",
    "population": 237551,
    "latitude": "56.15674",
    "longitude": "10.21076",
    "tier": 3
  },
  {
    "name": "Odense",
    "countryCode": "DK",
    "stateCode": "21",
    "population": 145931,
    "latitude": "55.39594",
    "longitude": "10.38831",
    "tier": 3
  },
  {
    "name": "Aalborg",
    "countryCode": "DK",
    "stateCode": "19",
    "population": 122219,
    "latitude": "57.048",
    "longitude": "9.9187",
    "tier": 3
  },
  {
    "name": "Frederiksberg",
    "countryCode": "DK",
    "stateCode": "17",
    "population": 95029,
    "latitude": "55.67938",
    "longitude": "12.53463",
    "tier": 3
  },
  {
    "name": "Esbjerg",
    "countryCode": "DK",
    "stateCode": "21",
    "population": 72205,
    "latitude": "55.47028",
    "longitude": "8.45187",
    "tier": 3
  },
  {
    "name": "Horsens",
    "countryCode": "DK",
    "stateCode": "18",
    "population": 58646,
    "latitude": "55.86066",
    "longitude": "9.85034",
    "tier": 3
  },
  {
    "name": "Randers",
    "countryCode": "DK",
    "stateCode": "18",
    "population": 55780,
    "latitude": "56.4607",
    "longitude": "10.03639",
    "tier": 3
  },
  {
    "name": "Helsinki",
    "countryCode": "FI",
    "stateCode": "01",
    "population": 558457,
    "latitude": "60.16952",
    "longitude": "24.93545",
    "tier": 3
  },
  {
    "name": "Espoo",
    "countryCode": "FI",
    "stateCode": "01",
    "population": 256760,
    "latitude": "60.2052",
    "longitude": "24.6522",
    "tier": 3
  },
  {
    "name": "Tampere",
    "countryCode": "FI",
    "stateCode": "06",
    "population": 202687,
    "latitude": "61.49911",
    "longitude": "23.78712",
    "tier": 3
  },
  {
    "name": "Vantaa",
    "countryCode": "FI",
    "stateCode": "01",
    "population": 190058,
    "latitude": "60.29414",
    "longitude": "25.04099",
    "tier": 3
  },
  {
    "name": "Turku",
    "countryCode": "FI",
    "stateCode": "02",
    "population": 175945,
    "latitude": "60.45148",
    "longitude": "22.26869",
    "tier": 3
  },
  {
    "name": "Oulu",
    "countryCode": "FI",
    "stateCode": "17",
    "population": 128618,
    "latitude": "65.01236",
    "longitude": "25.46816",
    "tier": 3
  },
  {
    "name": "Lahti",
    "countryCode": "FI",
    "stateCode": "07",
    "population": 98826,
    "latitude": "60.98267",
    "longitude": "25.66151",
    "tier": 3
  },
  {
    "name": "Kuopio",
    "countryCode": "FI",
    "stateCode": "11",
    "population": 89104,
    "latitude": "62.89238",
    "longitude": "27.67703",
    "tier": 3
  },
  {
    "name": "Zürich",
    "countryCode": "CH",
    "stateCode": "ZH",
    "population": 341730,
    "latitude": "47.36667",
    "longitude": "8.55",
    "tier": 3
  },
  {
    "name": "Genève",
    "countryCode": "CH",
    "stateCode": "GE",
    "population": 183981,
    "latitude": "46.20222",
    "longitude": "6.14569",
    "tier": 3
  },
  {
    "name": "Basel",
    "countryCode": "CH",
    "stateCode": "BS",
    "population": 164488,
    "latitude": "47.55839",
    "longitude": "7.57327",
    "tier": 3
  },
  {
    "name": "Bern",
    "countryCode": "CH",
    "stateCode": "BE",
    "population": 121631,
    "latitude": "46.94809",
    "longitude": "7.44744",
    "tier": 3
  },
  {
    "name": "Lausanne",
    "countryCode": "CH",
    "stateCode": "VD",
    "population": 116751,
    "latitude": "46.516",
    "longitude": "6.63282",
    "tier": 3
  },
  {
    "name": "Winterthur",
    "countryCode": "CH",
    "stateCode": "ZH",
    "population": 91908,
    "latitude": "47.50564",
    "longitude": "8.72413",
    "tier": 3
  },
  {
    "name": "Sankt Gallen",
    "countryCode": "CH",
    "stateCode": "SG",
    "population": 70572,
    "latitude": "47.42391",
    "longitude": "9.37477",
    "tier": 3
  },
  {
    "name": "Lugano",
    "countryCode": "CH",
    "stateCode": "TI",
    "population": 63000,
    "latitude": "46.01008",
    "longitude": "8.96004",
    "tier": 3
  },
  {
    "name": "Vienna",
    "countryCode": "AT",
    "stateCode": "09",
    "population": 1691468,
    "latitude": "48.20849",
    "longitude": "16.37208",
    "tier": 3
  },
  {
    "name": "Graz",
    "countryCode": "AT",
    "stateCode": "06",
    "population": 222326,
    "latitude": "47.06667",
    "longitude": "15.45",
    "tier": 3
  },
  {
    "name": "Linz",
    "countryCode": "AT",
    "stateCode": "04",
    "population": 204846,
    "latitude": "48.30639",
    "longitude": "14.28611",
    "tier": 3
  },
  {
    "name": "Favoriten",
    "countryCode": "AT",
    "stateCode": "09",
    "population": 201882,
    "latitude": "48.16116",
    "longitude": "16.38233",
    "tier": 3
  },
  {
    "name": "Donaustadt",
    "countryCode": "AT",
    "stateCode": "09",
    "population": 187007,
    "latitude": "48.2333",
    "longitude": "16.46002",
    "tier": 3
  },
  {
    "name": "Floridsdorf",
    "countryCode": "AT",
    "stateCode": "09",
    "population": 162779,
    "latitude": "48.25",
    "longitude": "16.4",
    "tier": 3
  },
  {
    "name": "Salzburg",
    "countryCode": "AT",
    "stateCode": "05",
    "population": 153377,
    "latitude": "47.79941",
    "longitude": "13.04399",
    "tier": 3
  },
  {
    "name": "Innsbruck",
    "countryCode": "AT",
    "stateCode": "07",
    "population": 132493,
    "latitude": "47.26266",
    "longitude": "11.39454",
    "tier": 3
  },
  {
    "name": "Brussels",
    "countryCode": "BE",
    "stateCode": "BRU",
    "population": 1019022,
    "latitude": "50.85045",
    "longitude": "4.34878",
    "tier": 3
  },
  {
    "name": "Antwerpen",
    "countryCode": "BE",
    "stateCode": "VLG",
    "population": 459805,
    "latitude": "51.22047",
    "longitude": "4.40026",
    "tier": 3
  },
  {
    "name": "Gent",
    "countryCode": "BE",
    "stateCode": "VLG",
    "population": 231493,
    "latitude": "51.05",
    "longitude": "3.71667",
    "tier": 3
  },
  {
    "name": "Charleroi",
    "countryCode": "BE",
    "stateCode": "WAL",
    "population": 200132,
    "latitude": "50.41136",
    "longitude": "4.44448",
    "tier": 3
  },
  {
    "name": "Liège",
    "countryCode": "BE",
    "stateCode": "WAL",
    "population": 182597,
    "latitude": "50.63373",
    "longitude": "5.56749",
    "tier": 3
  },
  {
    "name": "Brugge",
    "countryCode": "BE",
    "stateCode": "VLG",
    "population": 116709,
    "latitude": "51.20892",
    "longitude": "3.22424",
    "tier": 3
  },
  {
    "name": "Namur",
    "countryCode": "BE",
    "stateCode": "WAL",
    "population": 106284,
    "latitude": "50.4669",
    "longitude": "4.86746",
    "tier": 3
  },
  {
    "name": "Leuven",
    "countryCode": "BE",
    "stateCode": "VLG",
    "population": 92892,
    "latitude": "50.87959",
    "longitude": "4.70093",
    "tier": 3
  },
  {
    "name": "Warsaw",
    "countryCode": "PL",
    "stateCode": "78",
    "population": 1702139,
    "latitude": "52.22977",
    "longitude": "21.01178",
    "tier": 3
  },
  {
    "name": "Łódź",
    "countryCode": "PL",
    "stateCode": "74",
    "population": 768755,
    "latitude": "51.77058",
    "longitude": "19.47395",
    "tier": 3
  },
  {
    "name": "Kraków",
    "countryCode": "PL",
    "stateCode": "77",
    "population": 755050,
    "latitude": "50.06143",
    "longitude": "19.93658",
    "tier": 3
  },
  {
    "name": "Wrocław",
    "countryCode": "PL",
    "stateCode": "72",
    "population": 634893,
    "latitude": "51.1",
    "longitude": "17.03333",
    "tier": 3
  },
  {
    "name": "Poznań",
    "countryCode": "PL",
    "stateCode": "86",
    "population": 570352,
    "latitude": "52.40692",
    "longitude": "16.92993",
    "tier": 3
  },
  {
    "name": "Gdańsk",
    "countryCode": "PL",
    "stateCode": "82",
    "population": 461865,
    "latitude": "54.35227",
    "longitude": "18.64912",
    "tier": 3
  },
  {
    "name": "Szczecin",
    "countryCode": "PL",
    "stateCode": "87",
    "population": 407811,
    "latitude": "53.42894",
    "longitude": "14.55302",
    "tier": 3
  },
  {
    "name": "Bydgoszcz",
    "countryCode": "PL",
    "stateCode": "73",
    "population": 366452,
    "latitude": "53.1235",
    "longitude": "18.00762",
    "tier": 3
  },
  {
    "name": "Prague",
    "countryCode": "CZ",
    "stateCode": "52",
    "population": 1165581,
    "latitude": "50.08804",
    "longitude": "14.42076",
    "tier": 3
  },
  {
    "name": "Brno",
    "countryCode": "CZ",
    "stateCode": "78",
    "population": 369559,
    "latitude": "49.19522",
    "longitude": "16.60796",
    "tier": 3
  },
  {
    "name": "Ostrava",
    "countryCode": "CZ",
    "stateCode": "85",
    "population": 313088,
    "latitude": "49.83465",
    "longitude": "18.28204",
    "tier": 3
  },
  {
    "name": "Pilsen",
    "countryCode": "CZ",
    "stateCode": "87",
    "population": 164180,
    "latitude": "49.74747",
    "longitude": "13.37759",
    "tier": 3
  },
  {
    "name": "Olomouc",
    "countryCode": "CZ",
    "stateCode": "84",
    "population": 101268,
    "latitude": "49.59552",
    "longitude": "17.25175",
    "tier": 3
  },
  {
    "name": "Liberec",
    "countryCode": "CZ",
    "stateCode": "83",
    "population": 97770,
    "latitude": "50.76711",
    "longitude": "15.05619",
    "tier": 3
  },
  {
    "name": "České Budějovice",
    "countryCode": "CZ",
    "stateCode": "79",
    "population": 96053,
    "latitude": "48.97447",
    "longitude": "14.47434",
    "tier": 3
  },
  {
    "name": "Hradec Králové",
    "countryCode": "CZ",
    "stateCode": "82",
    "population": 95195,
    "latitude": "50.20923",
    "longitude": "15.83277",
    "tier": 3
  },
  {
    "name": "Tokyo",
    "countryCode": "JP",
    "stateCode": "40",
    "population": 8336599,
    "latitude": "35.6895",
    "longitude": "139.69171",
    "tier": 3
  },
  {
    "name": "Yokohama",
    "countryCode": "JP",
    "stateCode": "19",
    "population": 3574443,
    "latitude": "35.43333",
    "longitude": "139.65",
    "tier": 3
  },
  {
    "name": "Osaka",
    "countryCode": "JP",
    "stateCode": "32",
    "population": 2592413,
    "latitude": "34.69374",
    "longitude": "135.50218",
    "tier": 3
  },
  {
    "name": "Nagoya",
    "countryCode": "JP",
    "stateCode": "01",
    "population": 2191279,
    "latitude": "35.18147",
    "longitude": "136.90641",
    "tier": 3
  },
  {
    "name": "Sapporo",
    "countryCode": "JP",
    "stateCode": "12",
    "population": 1883027,
    "latitude": "43.06667",
    "longitude": "141.35",
    "tier": 3
  },
  {
    "name": "Kobe",
    "countryCode": "JP",
    "stateCode": "13",
    "population": 1528478,
    "latitude": "34.6913",
    "longitude": "135.183",
    "tier": 3
  },
  {
    "name": "Kyoto",
    "countryCode": "JP",
    "stateCode": "22",
    "population": 1459640,
    "latitude": "35.02107",
    "longitude": "135.75385",
    "tier": 3
  },
  {
    "name": "Fukuoka",
    "countryCode": "JP",
    "stateCode": "07",
    "population": 1392289,
    "latitude": "33.6",
    "longitude": "130.41667",
    "tier": 3
  },
  {
    "name": "Seoul",
    "countryCode": "KR",
    "stateCode": "11",
    "population": 10349312,
    "latitude": "37.566",
    "longitude": "126.9784",
    "tier": 3
  },
  {
    "name": "Busan",
    "countryCode": "KR",
    "stateCode": "10",
    "population": 3678555,
    "latitude": "35.10168",
    "longitude": "129.03004",
    "tier": 3
  },
  {
    "name": "Incheon",
    "countryCode": "KR",
    "stateCode": "12",
    "population": 2628000,
    "latitude": "37.45646",
    "longitude": "126.70515",
    "tier": 3
  },
  {
    "name": "Daegu",
    "countryCode": "KR",
    "stateCode": "15",
    "population": 2566540,
    "latitude": "35.87028",
    "longitude": "128.59111",
    "tier": 3
  },
  {
    "name": "Daejeon",
    "countryCode": "KR",
    "stateCode": "19",
    "population": 1475221,
    "latitude": "36.34913",
    "longitude": "127.38493",
    "tier": 3
  },
  {
    "name": "Gwangju",
    "countryCode": "KR",
    "stateCode": "18",
    "population": 1416938,
    "latitude": "35.15472",
    "longitude": "126.91556",
    "tier": 3
  },
  {
    "name": "Suwon",
    "countryCode": "KR",
    "stateCode": "13",
    "population": 1242724,
    "latitude": "37.29111",
    "longitude": "127.00889",
    "tier": 3
  },
  {
    "name": "Goyang-si",
    "countryCode": "KR",
    "stateCode": "13",
    "population": 1073069,
    "latitude": "37.65639",
    "longitude": "126.835",
    "tier": 3
  },
  {
    "name": "Singapore",
    "countryCode": "SG",
    "stateCode": "01",
    "population": 3547809,
    "latitude": "1.28967",
    "longitude": "103.85007",
    "tier": 3
  },
  {
    "name": "Woodlands",
    "countryCode": "SG",
    "stateCode": "03",
    "population": 252530,
    "latitude": "1.43801",
    "longitude": "103.78877",
    "tier": 3
  },
  {
    "name": "Hong Kong",
    "countryCode": "HK",
    "stateCode": "HCW",
    "population": 7012738,
    "latitude": "22.27832",
    "longitude": "114.17469",
    "tier": 3
  },
  {
    "name": "Kowloon",
    "countryCode": "HK",
    "stateCode": "KKC",
    "population": 2019533,
    "latitude": "22.31667",
    "longitude": "114.18333",
    "tier": 3
  },
  {
    "name": "Tsuen Wan",
    "countryCode": "HK",
    "stateCode": "NTW",
    "population": 288728,
    "latitude": "22.37137",
    "longitude": "114.11329",
    "tier": 3
  },
  {
    "name": "Yuen Long Kau Hui",
    "countryCode": "HK",
    "stateCode": "NYL",
    "population": 141900,
    "latitude": "22.45",
    "longitude": "114.03333",
    "tier": 3
  },
  {
    "name": "Tung Chung",
    "countryCode": "HK",
    "stateCode": "NIS",
    "population": 45000,
    "latitude": "22.28783",
    "longitude": "113.94243",
    "tier": 3
  },
  {
    "name": "Sha Tin",
    "countryCode": "HK",
    "stateCode": "NST",
    "population": 21559,
    "latitude": "22.38333",
    "longitude": "114.18333",
    "tier": 3
  },
  {
    "name": "Tuen Mun",
    "countryCode": "HK",
    "stateCode": "NTM",
    "population": 16940,
    "latitude": "22.39175",
    "longitude": "113.97157",
    "tier": 3
  },
  {
    "name": "Tai Po",
    "countryCode": "HK",
    "stateCode": "NTP",
    "population": 16302,
    "latitude": "22.45007",
    "longitude": "114.16877",
    "tier": 3
  },
  {
    "name": "Mumbai",
    "countryCode": "IN",
    "stateCode": "16",
    "population": 12691836,
    "latitude": "19.07283",
    "longitude": "72.88261",
    "tier": 3
  },
  {
    "name": "Delhi",
    "countryCode": "IN",
    "stateCode": "07",
    "population": 10927986,
    "latitude": "28.65195",
    "longitude": "77.23149",
    "tier": 3
  },
  {
    "name": "Bengaluru",
    "countryCode": "IN",
    "stateCode": "19",
    "population": 5104047,
    "latitude": "12.97194",
    "longitude": "77.59369",
    "tier": 3
  },
  {
    "name": "Kolkata",
    "countryCode": "IN",
    "stateCode": "28",
    "population": 4631392,
    "latitude": "22.56263",
    "longitude": "88.36304",
    "tier": 3
  },
  {
    "name": "Chennai",
    "countryCode": "IN",
    "stateCode": "25",
    "population": 4328063,
    "latitude": "13.08784",
    "longitude": "80.27847",
    "tier": 3
  },
  {
    "name": "Ahmedabad",
    "countryCode": "IN",
    "stateCode": "09",
    "population": 3719710,
    "latitude": "23.02579",
    "longitude": "72.58727",
    "tier": 3
  },
  {
    "name": "Hyderabad",
    "countryCode": "IN",
    "stateCode": "40",
    "population": 3597816,
    "latitude": "17.38405",
    "longitude": "78.45636",
    "tier": 3
  },
  {
    "name": "Pune",
    "countryCode": "IN",
    "stateCode": "16",
    "population": 2935744,
    "latitude": "18.51957",
    "longitude": "73.85535",
    "tier": 3
  },
  {
    "name": "Mexico City",
    "countryCode": "MX",
    "stateCode": "09",
    "population": 12294193,
    "latitude": "19.42847",
    "longitude": "-99.12766",
    "tier": 3
  },
  {
    "name": "Iztapalapa",
    "countryCode": "MX",
    "stateCode": "09",
    "population": 1815786,
    "latitude": "19.35529",
    "longitude": "-99.06224",
    "tier": 3
  },
  {
    "name": "Ecatepec de Morelos",
    "countryCode": "MX",
    "stateCode": "15",
    "population": 1655015,
    "latitude": "19.60492",
    "longitude": "-99.06064",
    "tier": 3
  },
  {
    "name": "Guadalajara",
    "countryCode": "MX",
    "stateCode": "14",
    "population": 1495182,
    "latitude": "20.66682",
    "longitude": "-103.39182",
    "tier": 3
  },
  {
    "name": "Puebla",
    "countryCode": "MX",
    "stateCode": "21",
    "population": 1434062,
    "latitude": "19.03793",
    "longitude": "-98.20346",
    "tier": 3
  },
  {
    "name": "Juárez",
    "countryCode": "MX",
    "stateCode": "06",
    "population": 1321004,
    "latitude": "31.72024",
    "longitude": "-106.46084",
    "tier": 3
  },
  {
    "name": "Tijuana",
    "countryCode": "MX",
    "stateCode": "02",
    "population": 1300983,
    "latitude": "32.5027",
    "longitude": "-117.00371",
    "tier": 3
  },
  {
    "name": "León de los Aldama",
    "countryCode": "MX",
    "stateCode": "11",
    "population": 1238962,
    "latitude": "21.12908",
    "longitude": "-101.67374",
    "tier": 3
  },
  {
    "name": "Buenos Aires",
    "countryCode": "AR",
    "stateCode": "07",
    "population": 13076300,
    "latitude": "-34.61315",
    "longitude": "-58.37723",
    "tier": 3
  },
  {
    "name": "Córdoba",
    "countryCode": "AR",
    "stateCode": "05",
    "population": 1428214,
    "latitude": "-31.4135",
    "longitude": "-64.18105",
    "tier": 3
  },
  {
    "name": "Rosario",
    "countryCode": "AR",
    "stateCode": "21",
    "population": 1173533,
    "latitude": "-32.94682",
    "longitude": "-60.63932",
    "tier": 3
  },
  {
    "name": "Mendoza",
    "countryCode": "AR",
    "stateCode": "13",
    "population": 876884,
    "latitude": "-32.89084",
    "longitude": "-68.82717",
    "tier": 3
  },
  {
    "name": "San Miguel de Tucumán",
    "countryCode": "AR",
    "stateCode": "24",
    "population": 781023,
    "latitude": "-26.82414",
    "longitude": "-65.2226",
    "tier": 3
  },
  {
    "name": "La Plata",
    "countryCode": "AR",
    "stateCode": "01",
    "population": 694167,
    "latitude": "-34.92145",
    "longitude": "-57.95453",
    "tier": 3
  },
  {
    "name": "Mar del Plata",
    "countryCode": "AR",
    "stateCode": "01",
    "population": 553935,
    "latitude": "-38.00042",
    "longitude": "-57.5562",
    "tier": 3
  },
  {
    "name": "Salta",
    "countryCode": "AR",
    "stateCode": "17",
    "population": 512686,
    "latitude": "-24.7859",
    "longitude": "-65.41166",
    "tier": 3
  },
  {
    "name": "Santiago",
    "countryCode": "CL",
    "stateCode": "12",
    "population": 4837295,
    "latitude": "-33.45694",
    "longitude": "-70.64827",
    "tier": 3
  },
  {
    "name": "Puente Alto",
    "countryCode": "CL",
    "stateCode": "12",
    "population": 510417,
    "latitude": "-33.61169",
    "longitude": "-70.57577",
    "tier": 3
  },
  {
    "name": "Antofagasta",
    "countryCode": "CL",
    "stateCode": "03",
    "population": 309832,
    "latitude": "-23.65236",
    "longitude": "-70.3954",
    "tier": 3
  },
  {
    "name": "Viña del Mar",
    "countryCode": "CL",
    "stateCode": "01",
    "population": 294551,
    "latitude": "-33.02457",
    "longitude": "-71.55183",
    "tier": 3
  },
  {
    "name": "Valparaíso",
    "countryCode": "CL",
    "stateCode": "01",
    "population": 282448,
    "latitude": "-33.036",
    "longitude": "-71.62963",
    "tier": 3
  },
  {
    "name": "Talcahuano",
    "countryCode": "CL",
    "stateCode": "06",
    "population": 252968,
    "latitude": "-36.72494",
    "longitude": "-73.11684",
    "tier": 3
  },
  {
    "name": "San Bernardo",
    "countryCode": "CL",
    "stateCode": "12",
    "population": 249858,
    "latitude": "-33.59217",
    "longitude": "-70.6996",
    "tier": 3
  },
  {
    "name": "Temuco",
    "countryCode": "CL",
    "stateCode": "04",
    "population": 238129,
    "latitude": "-38.73965",
    "longitude": "-72.59842",
    "tier": 3
  },
  {
    "name": "Bogotá",
    "countryCode": "CO",
    "stateCode": "34",
    "population": 7674366,
    "latitude": "4.60971",
    "longitude": "-74.08175",
    "tier": 3
  },
  {
    "name": "Cali",
    "countryCode": "CO",
    "stateCode": "29",
    "population": 2392877,
    "latitude": "3.43722",
    "longitude": "-76.5225",
    "tier": 3
  },
  {
    "name": "Medellín",
    "countryCode": "CO",
    "stateCode": "02",
    "population": 1999979,
    "latitude": "6.25184",
    "longitude": "-75.56359",
    "tier": 3
  },
  {
    "name": "Barranquilla",
    "countryCode": "CO",
    "stateCode": "04",
    "population": 1380425,
    "latitude": "10.96854",
    "longitude": "-74.78132",
    "tier": 3
  },
  {
    "name": "Cartagena",
    "countryCode": "CO",
    "stateCode": "35",
    "population": 952024,
    "latitude": "10.39972",
    "longitude": "-75.51444",
    "tier": 3
  },
  {
    "name": "Cúcuta",
    "countryCode": "CO",
    "stateCode": "21",
    "population": 721398,
    "latitude": "7.89391",
    "longitude": "-72.50782",
    "tier": 3
  },
  {
    "name": "Bucaramanga",
    "countryCode": "CO",
    "stateCode": "26",
    "population": 571820,
    "latitude": "7.12539",
    "longitude": "-73.1198",
    "tier": 3
  },
  {
    "name": "Pereira",
    "countryCode": "CO",
    "stateCode": "24",
    "population": 440118,
    "latitude": "4.81333",
    "longitude": "-75.69611",
    "tier": 3
  },
  {
    "name": "Dubai",
    "countryCode": "AE",
    "stateCode": "03",
    "population": 2956587,
    "latitude": "25.07725",
    "longitude": "55.30927",
    "tier": 4
  },
  {
    "name": "Sharjah",
    "countryCode": "AE",
    "stateCode": "06",
    "population": 1324473,
    "latitude": "25.33737",
    "longitude": "55.41206",
    "tier": 4
  },
  {
    "name": "Abu Dhabi",
    "countryCode": "AE",
    "stateCode": "01",
    "population": 603492,
    "latitude": "24.45118",
    "longitude": "54.39696",
    "tier": 4
  },
  {
    "name": "Kabul",
    "countryCode": "AF",
    "stateCode": "13",
    "population": 3043532,
    "latitude": "34.52813",
    "longitude": "69.17233",
    "tier": 4
  },
  {
    "name": "Kandahār",
    "countryCode": "AF",
    "stateCode": "23",
    "population": 391190,
    "latitude": "31.61332",
    "longitude": "65.71013",
    "tier": 4
  },
  {
    "name": "Mazār-e Sharīf",
    "countryCode": "AF",
    "stateCode": "30",
    "population": 303282,
    "latitude": "36.70904",
    "longitude": "67.11087",
    "tier": 4
  },
  {
    "name": "Tirana",
    "countryCode": "AL",
    "stateCode": "50",
    "population": 374801,
    "latitude": "41.3275",
    "longitude": "19.81889",
    "tier": 4
  },
  {
    "name": "Durrës",
    "countryCode": "AL",
    "stateCode": "42",
    "population": 122034,
    "latitude": "41.32355",
    "longitude": "19.45469",
    "tier": 4
  },
  {
    "name": "Elbasan",
    "countryCode": "AL",
    "stateCode": "43",
    "population": 100903,
    "latitude": "41.1125",
    "longitude": "20.08222",
    "tier": 4
  },
  {
    "name": "Yerevan",
    "countryCode": "AM",
    "stateCode": "11",
    "population": 1093485,
    "latitude": "40.18111",
    "longitude": "44.51361",
    "tier": 4
  },
  {
    "name": "Gyumri",
    "countryCode": "AM",
    "stateCode": "07",
    "population": 148381,
    "latitude": "40.7942",
    "longitude": "43.84528",
    "tier": 4
  },
  {
    "name": "Vanadzor",
    "countryCode": "AM",
    "stateCode": "06",
    "population": 101098,
    "latitude": "40.80456",
    "longitude": "44.4939",
    "tier": 4
  },
  {
    "name": "Luanda",
    "countryCode": "AO",
    "stateCode": "20",
    "population": 2776168,
    "latitude": "-8.83682",
    "longitude": "13.23432",
    "tier": 4
  },
  {
    "name": "N’dalatando",
    "countryCode": "AO",
    "stateCode": "05",
    "population": 383100,
    "latitude": "-9.29782",
    "longitude": "14.91162",
    "tier": 4
  },
  {
    "name": "Huambo",
    "countryCode": "AO",
    "stateCode": "08",
    "population": 226145,
    "latitude": "-12.77611",
    "longitude": "15.73917",
    "tier": 4
  },
  {
    "name": "Baku",
    "countryCode": "AZ",
    "stateCode": "09",
    "population": 1116513,
    "latitude": "40.37767",
    "longitude": "49.89201",
    "tier": 4
  },
  {
    "name": "Ganja",
    "countryCode": "AZ",
    "stateCode": "20",
    "population": 313300,
    "latitude": "40.68278",
    "longitude": "46.36056",
    "tier": 4
  },
  {
    "name": "Sumqayıt",
    "countryCode": "AZ",
    "stateCode": "54",
    "population": 265150,
    "latitude": "40.58972",
    "longitude": "49.66861",
    "tier": 4
  },
  {
    "name": "Sarajevo",
    "countryCode": "BA",
    "stateCode": "01",
    "population": 696731,
    "latitude": "43.84864",
    "longitude": "18.35644",
    "tier": 4
  },
  {
    "name": "Banja Luka",
    "countryCode": "BA",
    "stateCode": "02",
    "population": 221106,
    "latitude": "44.77842",
    "longitude": "17.19386",
    "tier": 4
  },
  {
    "name": "Zenica",
    "countryCode": "BA",
    "stateCode": "01",
    "population": 164423,
    "latitude": "44.20169",
    "longitude": "17.90397",
    "tier": 4
  },
  {
    "name": "Dhaka",
    "countryCode": "BD",
    "stateCode": "81",
    "population": 10356500,
    "latitude": "23.7104",
    "longitude": "90.40744",
    "tier": 4
  },
  {
    "name": "Chittagong",
    "countryCode": "BD",
    "stateCode": "84",
    "population": 3920222,
    "latitude": "22.3384",
    "longitude": "91.83168",
    "tier": 4
  },
  {
    "name": "Khulna",
    "countryCode": "BD",
    "stateCode": "82",
    "population": 1342339,
    "latitude": "22.80979",
    "longitude": "89.56439",
    "tier": 4
  },
  {
    "name": "Ouagadougou",
    "countryCode": "BF",
    "stateCode": "03",
    "population": 1086505,
    "latitude": "12.36566",
    "longitude": "-1.53388",
    "tier": 4
  },
  {
    "name": "Bobo-Dioulasso",
    "countryCode": "BF",
    "stateCode": "09",
    "population": 360106,
    "latitude": "11.17715",
    "longitude": "-4.2979",
    "tier": 4
  },
  {
    "name": "Sofia",
    "countryCode": "BG",
    "stateCode": "42",
    "population": 1152556,
    "latitude": "42.69751",
    "longitude": "23.32415",
    "tier": 4
  },
  {
    "name": "Plovdiv",
    "countryCode": "BG",
    "stateCode": "51",
    "population": 340494,
    "latitude": "42.15",
    "longitude": "24.75",
    "tier": 4
  },
  {
    "name": "Varna",
    "countryCode": "BG",
    "stateCode": "61",
    "population": 312770,
    "latitude": "43.21667",
    "longitude": "27.91667",
    "tier": 4
  },
  {
    "name": "Manama",
    "countryCode": "BH",
    "stateCode": "16",
    "population": 147074,
    "latitude": "26.22787",
    "longitude": "50.58565",
    "tier": 4
  },
  {
    "name": "Bujumbura",
    "countryCode": "BI",
    "stateCode": "24",
    "population": 331700,
    "latitude": "-3.38193",
    "longitude": "29.36142",
    "tier": 4
  },
  {
    "name": "Cotonou",
    "countryCode": "BJ",
    "stateCode": "14",
    "population": 780000,
    "latitude": "6.36536",
    "longitude": "2.41833",
    "tier": 4
  },
  {
    "name": "Abomey-Calavi",
    "countryCode": "BJ",
    "stateCode": "09",
    "population": 385755,
    "latitude": "6.44852",
    "longitude": "2.35566",
    "tier": 4
  },
  {
    "name": "Djougou",
    "countryCode": "BJ",
    "stateCode": "13",
    "population": 237040,
    "latitude": "9.70853",
    "longitude": "1.66598",
    "tier": 4
  },
  {
    "name": "Santa Cruz de la Sierra",
    "countryCode": "BO",
    "stateCode": "08",
    "population": 1364389,
    "latitude": "-17.78629",
    "longitude": "-63.18117",
    "tier": 4
  },
  {
    "name": "Cochabamba",
    "countryCode": "BO",
    "stateCode": "02",
    "population": 900414,
    "latitude": "-17.3895",
    "longitude": "-66.1568",
    "tier": 4
  },
  {
    "name": "La Paz",
    "countryCode": "BO",
    "stateCode": "04",
    "population": 812799,
    "latitude": "-16.5",
    "longitude": "-68.15",
    "tier": 4
  },
  {
    "name": "Nassau",
    "countryCode": "BS",
    "stateCode": "23",
    "population": 227940,
    "latitude": "25.05823",
    "longitude": "-77.34306",
    "tier": 4
  },
  {
    "name": "Gaborone",
    "countryCode": "BW",
    "stateCode": "14",
    "population": 208411,
    "latitude": "-24.65451",
    "longitude": "25.90859",
    "tier": 4
  },
  {
    "name": "Minsk",
    "countryCode": "BY",
    "stateCode": "04",
    "population": 1742124,
    "latitude": "53.9",
    "longitude": "27.56667",
    "tier": 4
  },
  {
    "name": "Homyel'",
    "countryCode": "BY",
    "stateCode": "02",
    "population": 480951,
    "latitude": "52.4345",
    "longitude": "30.9754",
    "tier": 4
  },
  {
    "name": "Mahilyow",
    "countryCode": "BY",
    "stateCode": "06",
    "population": 369200,
    "latitude": "53.9168",
    "longitude": "30.3449",
    "tier": 4
  },
  {
    "name": "Kinshasa",
    "countryCode": "CD",
    "stateCode": "06",
    "population": 7785965,
    "latitude": "-4.32758",
    "longitude": "15.31357",
    "tier": 4
  },
  {
    "name": "Lubumbashi",
    "countryCode": "CD",
    "stateCode": "14",
    "population": 1373770,
    "latitude": "-11.66089",
    "longitude": "27.47938",
    "tier": 4
  },
  {
    "name": "Mbuji-Mayi",
    "countryCode": "CD",
    "stateCode": "04",
    "population": 874761,
    "latitude": "-6.13603",
    "longitude": "23.58979",
    "tier": 4
  },
  {
    "name": "Bangui",
    "countryCode": "CF",
    "stateCode": "18",
    "population": 542393,
    "latitude": "4.36122",
    "longitude": "18.55496",
    "tier": 4
  },
  {
    "name": "Bimbo",
    "countryCode": "CF",
    "stateCode": "17",
    "population": 129655,
    "latitude": "4.25671",
    "longitude": "18.41583",
    "tier": 4
  },
  {
    "name": "Brazzaville",
    "countryCode": "CG",
    "stateCode": "12",
    "population": 1284609,
    "latitude": "-4.26613",
    "longitude": "15.28318",
    "tier": 4
  },
  {
    "name": "Pointe-Noire",
    "countryCode": "CG",
    "stateCode": "15",
    "population": 659084,
    "latitude": "-4.77609",
    "longitude": "11.86352",
    "tier": 4
  },
  {
    "name": "Dolisie",
    "countryCode": "CG",
    "stateCode": "07",
    "population": 103894,
    "latitude": "-4.19834",
    "longitude": "12.66664",
    "tier": 4
  },
  {
    "name": "Abidjan",
    "countryCode": "CI",
    "stateCode": "93",
    "population": 3677115,
    "latitude": "5.35444",
    "longitude": "-4.00167",
    "tier": 4
  },
  {
    "name": "Abobo",
    "countryCode": "CI",
    "stateCode": "93",
    "population": 900000,
    "latitude": "5.41613",
    "longitude": "-4.0159",
    "tier": 4
  },
  {
    "name": "Bouaké",
    "countryCode": "CI",
    "stateCode": "90",
    "population": 567481,
    "latitude": "7.69385",
    "longitude": "-5.03031",
    "tier": 4
  },
  {
    "name": "Douala",
    "countryCode": "CM",
    "stateCode": "05",
    "population": 1338082,
    "latitude": "4.04827",
    "longitude": "9.70428",
    "tier": 4
  },
  {
    "name": "Yaoundé",
    "countryCode": "CM",
    "stateCode": "11",
    "population": 1299369,
    "latitude": "3.86667",
    "longitude": "11.51667",
    "tier": 4
  },
  {
    "name": "Garoua",
    "countryCode": "CM",
    "stateCode": "13",
    "population": 436899,
    "latitude": "9.30143",
    "longitude": "13.39771",
    "tier": 4
  },
  {
    "name": "Shanghai",
    "countryCode": "CN",
    "stateCode": "23",
    "population": 22315474,
    "latitude": "31.22222",
    "longitude": "121.45806",
    "tier": 4
  },
  {
    "name": "Beijing",
    "countryCode": "CN",
    "stateCode": "22",
    "population": 11716620,
    "latitude": "39.9075",
    "longitude": "116.39723",
    "tier": 4
  },
  {
    "name": "Tianjin",
    "countryCode": "CN",
    "stateCode": "28",
    "population": 11090314,
    "latitude": "39.14222",
    "longitude": "117.17667",
    "tier": 4
  },
  {
    "name": "San José",
    "countryCode": "CR",
    "stateCode": "08",
    "population": 335007,
    "latitude": "9.93333",
    "longitude": "-84.08333",
    "tier": 4
  },
  {
    "name": "Havana",
    "countryCode": "CU",
    "stateCode": "02",
    "population": 2163824,
    "latitude": "23.13302",
    "longitude": "-82.38304",
    "tier": 4
  },
  {
    "name": "Santiago de Cuba",
    "countryCode": "CU",
    "stateCode": "15",
    "population": 555865,
    "latitude": "20.02083",
    "longitude": "-75.82667",
    "tier": 4
  },
  {
    "name": "Camagüey",
    "countryCode": "CU",
    "stateCode": "05",
    "population": 347562,
    "latitude": "21.38083",
    "longitude": "-77.91694",
    "tier": 4
  },
  {
    "name": "Praia",
    "countryCode": "CV",
    "stateCode": "14",
    "population": 113364,
    "latitude": "14.93152",
    "longitude": "-23.51254",
    "tier": 4
  },
  {
    "name": "Willemstad",
    "countryCode": "CW",
    "stateCode": "",
    "population": 125000,
    "latitude": "12.1084",
    "longitude": "-68.93354",
    "tier": 4
  },
  {
    "name": "Nicosia",
    "countryCode": "CY",
    "stateCode": "04",
    "population": 200452,
    "latitude": "35.17531",
    "longitude": "33.3642",
    "tier": 4
  },
  {
    "name": "Limassol",
    "countryCode": "CY",
    "stateCode": "05",
    "population": 154000,
    "latitude": "34.68406",
    "longitude": "33.03794",
    "tier": 4
  },
  {
    "name": "Djibouti",
    "countryCode": "DJ",
    "stateCode": "07",
    "population": 623891,
    "latitude": "11.58901",
    "longitude": "43.14503",
    "tier": 4
  },
  {
    "name": "Santo Domingo",
    "countryCode": "DO",
    "stateCode": "34",
    "population": 2201941,
    "latitude": "18.47186",
    "longitude": "-69.89232",
    "tier": 4
  },
  {
    "name": "Santiago de los Caballeros",
    "countryCode": "DO",
    "stateCode": "25",
    "population": 1200000,
    "latitude": "19.4517",
    "longitude": "-70.69703",
    "tier": 4
  },
  {
    "name": "Santo Domingo Oeste",
    "countryCode": "DO",
    "stateCode": "37",
    "population": 701269,
    "latitude": "18.5",
    "longitude": "-70",
    "tier": 4
  },
  {
    "name": "Algiers",
    "countryCode": "DZ",
    "stateCode": "01",
    "population": 1977663,
    "latitude": "36.73225",
    "longitude": "3.08746",
    "tier": 4
  },
  {
    "name": "Boumerdas",
    "countryCode": "DZ",
    "stateCode": "40",
    "population": 786499,
    "latitude": "36.76639",
    "longitude": "3.47717",
    "tier": 4
  },
  {
    "name": "Oran",
    "countryCode": "DZ",
    "stateCode": "09",
    "population": 645984,
    "latitude": "35.69906",
    "longitude": "-0.63588",
    "tier": 4
  },
  {
    "name": "Guayaquil",
    "countryCode": "EC",
    "stateCode": "10",
    "population": 1952029,
    "latitude": "-2.19616",
    "longitude": "-79.88621",
    "tier": 4
  },
  {
    "name": "Quito",
    "countryCode": "EC",
    "stateCode": "18",
    "population": 1399814,
    "latitude": "-0.22985",
    "longitude": "-78.52495",
    "tier": 4
  },
  {
    "name": "Cuenca",
    "countryCode": "EC",
    "stateCode": "02",
    "population": 276964,
    "latitude": "-2.90055",
    "longitude": "-79.00453",
    "tier": 4
  },
  {
    "name": "Tallinn",
    "countryCode": "EE",
    "stateCode": "01",
    "population": 394024,
    "latitude": "59.43696",
    "longitude": "24.75353",
    "tier": 4
  },
  {
    "name": "Tartu",
    "countryCode": "EE",
    "stateCode": "18",
    "population": 101092,
    "latitude": "58.38062",
    "longitude": "26.72509",
    "tier": 4
  },
  {
    "name": "Cairo",
    "countryCode": "EG",
    "stateCode": "11",
    "population": 7734614,
    "latitude": "30.06263",
    "longitude": "31.24967",
    "tier": 4
  },
  {
    "name": "Alexandria",
    "countryCode": "EG",
    "stateCode": "06",
    "population": 3811516,
    "latitude": "31.20176",
    "longitude": "29.91582",
    "tier": 4
  },
  {
    "name": "Giza",
    "countryCode": "EG",
    "stateCode": "08",
    "population": 2443203,
    "latitude": "30.00944",
    "longitude": "31.20861",
    "tier": 4
  },
  {
    "name": "Laayoune",
    "countryCode": "EH",
    "stateCode": "",
    "population": 196331,
    "latitude": "27.1418",
    "longitude": "-13.18797",
    "tier": 4
  },
  {
    "name": "Asmara",
    "countryCode": "ER",
    "stateCode": "05",
    "population": 563930,
    "latitude": "15.33805",
    "longitude": "38.93184",
    "tier": 4
  },
  {
    "name": "Addis Ababa",
    "countryCode": "ET",
    "stateCode": "44",
    "population": 2757729,
    "latitude": "9.02497",
    "longitude": "38.74689",
    "tier": 4
  },
  {
    "name": "Dire Dawa",
    "countryCode": "ET",
    "stateCode": "48",
    "population": 252279,
    "latitude": "9.59306",
    "longitude": "41.86611",
    "tier": 4
  },
  {
    "name": "Mek'ele",
    "countryCode": "ET",
    "stateCode": "53",
    "population": 215546,
    "latitude": "13.49667",
    "longitude": "39.47528",
    "tier": 4
  },
  {
    "name": "Libreville",
    "countryCode": "GA",
    "stateCode": "01",
    "population": 578156,
    "latitude": "0.39241",
    "longitude": "9.45356",
    "tier": 4
  },
  {
    "name": "Port-Gentil",
    "countryCode": "GA",
    "stateCode": "08",
    "population": 109163,
    "latitude": "-0.71933",
    "longitude": "8.78151",
    "tier": 4
  },
  {
    "name": "Tbilisi",
    "countryCode": "GE",
    "stateCode": "51",
    "population": 1049498,
    "latitude": "41.69411",
    "longitude": "44.83368",
    "tier": 4
  },
  {
    "name": "Kutaisi",
    "countryCode": "GE",
    "stateCode": "66",
    "population": 178338,
    "latitude": "42.26791",
    "longitude": "42.69459",
    "tier": 4
  },
  {
    "name": "Batumi",
    "countryCode": "GE",
    "stateCode": "04",
    "population": 121806,
    "latitude": "41.64228",
    "longitude": "41.63392",
    "tier": 4
  },
  {
    "name": "Accra",
    "countryCode": "GH",
    "stateCode": "01",
    "population": 1963264,
    "latitude": "5.55602",
    "longitude": "-0.1969",
    "tier": 4
  },
  {
    "name": "Kumasi",
    "countryCode": "GH",
    "stateCode": "02",
    "population": 1468609,
    "latitude": "6.68848",
    "longitude": "-1.62443",
    "tier": 4
  },
  {
    "name": "Tamale",
    "countryCode": "GH",
    "stateCode": "06",
    "population": 360579,
    "latitude": "9.40079",
    "longitude": "-0.8393",
    "tier": 4
  },
  {
    "name": "Serekunda",
    "countryCode": "GM",
    "stateCode": "01",
    "population": 340000,
    "latitude": "13.43833",
    "longitude": "-16.67806",
    "tier": 4
  },
  {
    "name": "Camayenne",
    "countryCode": "GN",
    "stateCode": "04",
    "population": 1871242,
    "latitude": "9.535",
    "longitude": "-13.68778",
    "tier": 4
  },
  {
    "name": "Conakry",
    "countryCode": "GN",
    "stateCode": "04",
    "population": 1767200,
    "latitude": "9.53795",
    "longitude": "-13.67729",
    "tier": 4
  },
  {
    "name": "Nzérékoré",
    "countryCode": "GN",
    "stateCode": "N",
    "population": 132728,
    "latitude": "7.75624",
    "longitude": "-8.8179",
    "tier": 4
  },
  {
    "name": "Bata",
    "countryCode": "GQ",
    "stateCode": "08",
    "population": 173046,
    "latitude": "1.86391",
    "longitude": "9.76582",
    "tier": 4
  },
  {
    "name": "Malabo",
    "countryCode": "GQ",
    "stateCode": "04",
    "population": 155963,
    "latitude": "3.75578",
    "longitude": "8.78166",
    "tier": 4
  },
  {
    "name": "Athens",
    "countryCode": "GR",
    "stateCode": "ESYE31",
    "population": 664046,
    "latitude": "37.98376",
    "longitude": "23.72784",
    "tier": 4
  },
  {
    "name": "Thessaloníki",
    "countryCode": "GR",
    "stateCode": "ESYE12",
    "population": 354290,
    "latitude": "40.64361",
    "longitude": "22.93086",
    "tier": 4
  },
  {
    "name": "Pátra",
    "countryCode": "GR",
    "stateCode": "ESYE23",
    "population": 168034,
    "latitude": "38.24444",
    "longitude": "21.73444",
    "tier": 4
  },
  {
    "name": "Guatemala City",
    "countryCode": "GT",
    "stateCode": "07",
    "population": 994938,
    "latitude": "14.64072",
    "longitude": "-90.51327",
    "tier": 4
  },
  {
    "name": "Mixco",
    "countryCode": "GT",
    "stateCode": "07",
    "population": 473080,
    "latitude": "14.63077",
    "longitude": "-90.60711",
    "tier": 4
  },
  {
    "name": "Villa Nueva",
    "countryCode": "GT",
    "stateCode": "07",
    "population": 406830,
    "latitude": "14.52512",
    "longitude": "-90.58544",
    "tier": 4
  },
  {
    "name": "Bissau",
    "countryCode": "GW",
    "stateCode": "11",
    "population": 388028,
    "latitude": "11.86357",
    "longitude": "-15.59767",
    "tier": 4
  },
  {
    "name": "Georgetown",
    "countryCode": "GY",
    "stateCode": "12",
    "population": 235017,
    "latitude": "6.80448",
    "longitude": "-58.15527",
    "tier": 4
  },
  {
    "name": "Tegucigalpa",
    "countryCode": "HN",
    "stateCode": "08",
    "population": 850848,
    "latitude": "14.0818",
    "longitude": "-87.20681",
    "tier": 4
  },
  {
    "name": "San Pedro Sula",
    "countryCode": "HN",
    "stateCode": "06",
    "population": 489466,
    "latitude": "15.50417",
    "longitude": "-88.025",
    "tier": 4
  },
  {
    "name": "Choloma",
    "countryCode": "HN",
    "stateCode": "06",
    "population": 139100,
    "latitude": "15.61444",
    "longitude": "-87.95302",
    "tier": 4
  },
  {
    "name": "Zagreb",
    "countryCode": "HR",
    "stateCode": "21",
    "population": 698966,
    "latitude": "45.81444",
    "longitude": "15.97798",
    "tier": 4
  },
  {
    "name": "Split",
    "countryCode": "HR",
    "stateCode": "15",
    "population": 176314,
    "latitude": "43.50891",
    "longitude": "16.43915",
    "tier": 4
  },
  {
    "name": "Rijeka",
    "countryCode": "HR",
    "stateCode": "12",
    "population": 141172,
    "latitude": "45.32673",
    "longitude": "14.44241",
    "tier": 4
  },
  {
    "name": "Port-au-Prince",
    "countryCode": "HT",
    "stateCode": "11",
    "population": 1234742,
    "latitude": "18.54349",
    "longitude": "-72.33881",
    "tier": 4
  },
  {
    "name": "Carrefour",
    "countryCode": "HT",
    "stateCode": "11",
    "population": 442156,
    "latitude": "18.54114",
    "longitude": "-72.39922",
    "tier": 4
  },
  {
    "name": "Delmas 73",
    "countryCode": "HT",
    "stateCode": "11",
    "population": 382920,
    "latitude": "18.54472",
    "longitude": "-72.30278",
    "tier": 4
  },
  {
    "name": "Budapest",
    "countryCode": "HU",
    "stateCode": "05",
    "population": 1741041,
    "latitude": "47.49835",
    "longitude": "19.04045",
    "tier": 4
  },
  {
    "name": "Debrecen",
    "countryCode": "HU",
    "stateCode": "10",
    "population": 204124,
    "latitude": "47.53167",
    "longitude": "21.62444",
    "tier": 4
  },
  {
    "name": "Miskolc",
    "countryCode": "HU",
    "stateCode": "04",
    "population": 172637,
    "latitude": "48.10306",
    "longitude": "20.77806",
    "tier": 4
  },
  {
    "name": "Jakarta",
    "countryCode": "ID",
    "stateCode": "04",
    "population": 8540121,
    "latitude": "-6.21462",
    "longitude": "106.84513",
    "tier": 4
  },
  {
    "name": "Surabaya",
    "countryCode": "ID",
    "stateCode": "08",
    "population": 2374658,
    "latitude": "-7.24917",
    "longitude": "112.75083",
    "tier": 4
  },
  {
    "name": "Medan",
    "countryCode": "ID",
    "stateCode": "26",
    "population": 1750971,
    "latitude": "3.58333",
    "longitude": "98.66667",
    "tier": 4
  },
  {
    "name": "Jerusalem",
    "countryCode": "IL",
    "stateCode": "06",
    "population": 801000,
    "latitude": "31.76904",
    "longitude": "35.21633",
    "tier": 4
  },
  {
    "name": "Tel Aviv",
    "countryCode": "IL",
    "stateCode": "05",
    "population": 432892,
    "latitude": "32.08088",
    "longitude": "34.78057",
    "tier": 4
  },
  {
    "name": "West Jerusalem",
    "countryCode": "IL",
    "stateCode": "06",
    "population": 400000,
    "latitude": "31.78199",
    "longitude": "35.21961",
    "tier": 4
  },
  {
    "name": "Baghdad",
    "countryCode": "IQ",
    "stateCode": "07",
    "population": 7216000,
    "latitude": "33.34058",
    "longitude": "44.40088",
    "tier": 4
  },
  {
    "name": "Basrah",
    "countryCode": "IQ",
    "stateCode": "02",
    "population": 2600000,
    "latitude": "30.50852",
    "longitude": "47.7804",
    "tier": 4
  },
  {
    "name": "Al Mawşil al Jadīdah",
    "countryCode": "IQ",
    "stateCode": "15",
    "population": 2065597,
    "latitude": "36.33271",
    "longitude": "43.10555",
    "tier": 4
  },
  {
    "name": "Tehran",
    "countryCode": "IR",
    "stateCode": "26",
    "population": 7153309,
    "latitude": "35.69439",
    "longitude": "51.42151",
    "tier": 4
  },
  {
    "name": "Mashhad",
    "countryCode": "IR",
    "stateCode": "42",
    "population": 2307177,
    "latitude": "36.31559",
    "longitude": "59.56796",
    "tier": 4
  },
  {
    "name": "Isfahan",
    "countryCode": "IR",
    "stateCode": "28",
    "population": 1547164,
    "latitude": "32.65246",
    "longitude": "51.67462",
    "tier": 4
  },
  {
    "name": "Reykjavík",
    "countryCode": "IS",
    "stateCode": "39",
    "population": 118918,
    "latitude": "64.13548",
    "longitude": "-21.89541",
    "tier": 4
  },
  {
    "name": "Kingston",
    "countryCode": "JM",
    "stateCode": "17",
    "population": 937700,
    "latitude": "17.99702",
    "longitude": "-76.79358",
    "tier": 4
  },
  {
    "name": "New Kingston",
    "countryCode": "JM",
    "stateCode": "08",
    "population": 583958,
    "latitude": "18.00747",
    "longitude": "-76.78319",
    "tier": 4
  },
  {
    "name": "Spanish Town",
    "countryCode": "JM",
    "stateCode": "10",
    "population": 145018,
    "latitude": "17.99107",
    "longitude": "-76.95742",
    "tier": 4
  },
  {
    "name": "Amman",
    "countryCode": "JO",
    "stateCode": "16",
    "population": 1275857,
    "latitude": "31.95522",
    "longitude": "35.94503",
    "tier": 4
  },
  {
    "name": "Zarqa",
    "countryCode": "JO",
    "stateCode": "17",
    "population": 792665,
    "latitude": "32.07275",
    "longitude": "36.08796",
    "tier": 4
  },
  {
    "name": "Irbid",
    "countryCode": "JO",
    "stateCode": "18",
    "population": 307480,
    "latitude": "32.55556",
    "longitude": "35.85",
    "tier": 4
  },
  {
    "name": "Nairobi",
    "countryCode": "KE",
    "stateCode": "05",
    "population": 2750547,
    "latitude": "-1.28333",
    "longitude": "36.81667",
    "tier": 4
  },
  {
    "name": "Mombasa",
    "countryCode": "KE",
    "stateCode": "37",
    "population": 799668,
    "latitude": "-4.05466",
    "longitude": "39.66359",
    "tier": 4
  },
  {
    "name": "Nakuru",
    "countryCode": "KE",
    "stateCode": "39",
    "population": 259903,
    "latitude": "-0.30719",
    "longitude": "36.07225",
    "tier": 4
  },
  {
    "name": "Bishkek",
    "countryCode": "KG",
    "stateCode": "01",
    "population": 900000,
    "latitude": "42.87",
    "longitude": "74.59",
    "tier": 4
  },
  {
    "name": "Osh",
    "countryCode": "KG",
    "stateCode": "08",
    "population": 200000,
    "latitude": "40.52828",
    "longitude": "72.7985",
    "tier": 4
  },
  {
    "name": "Phnom Penh",
    "countryCode": "KH",
    "stateCode": "22",
    "population": 1573544,
    "latitude": "11.56245",
    "longitude": "104.91601",
    "tier": 4
  },
  {
    "name": "Takeo",
    "countryCode": "KH",
    "stateCode": "19",
    "population": 843931,
    "latitude": "10.99081",
    "longitude": "104.78498",
    "tier": 4
  },
  {
    "name": "Sihanoukville",
    "countryCode": "KH",
    "stateCode": "28",
    "population": 156691,
    "latitude": "10.60932",
    "longitude": "103.52958",
    "tier": 4
  },
  {
    "name": "Pyongyang",
    "countryCode": "KP",
    "stateCode": "12",
    "population": 3222000,
    "latitude": "39.03385",
    "longitude": "125.75432",
    "tier": 4
  },
  {
    "name": "Hamhŭng",
    "countryCode": "KP",
    "stateCode": "03",
    "population": 559056,
    "latitude": "39.91833",
    "longitude": "127.53639",
    "tier": 4
  },
  {
    "name": "Namp’o",
    "countryCode": "KP",
    "stateCode": "15",
    "population": 455000,
    "latitude": "38.7375",
    "longitude": "125.40778",
    "tier": 4
  },
  {
    "name": "Al Aḩmadī",
    "countryCode": "KW",
    "stateCode": "04",
    "population": 637411,
    "latitude": "29.07694",
    "longitude": "48.08389",
    "tier": 4
  },
  {
    "name": "Ḩawallī",
    "countryCode": "KW",
    "stateCode": "08",
    "population": 164212,
    "latitude": "29.33278",
    "longitude": "48.02861",
    "tier": 4
  },
  {
    "name": "As Sālimīyah",
    "countryCode": "KW",
    "stateCode": "08",
    "population": 147649,
    "latitude": "29.33389",
    "longitude": "48.07611",
    "tier": 4
  },
  {
    "name": "Almaty",
    "countryCode": "KZ",
    "stateCode": "02",
    "population": 2000900,
    "latitude": "43.25667",
    "longitude": "76.92861",
    "tier": 4
  },
  {
    "name": "Karagandy",
    "countryCode": "KZ",
    "stateCode": "12",
    "population": 451800,
    "latitude": "49.80187",
    "longitude": "73.10211",
    "tier": 4
  },
  {
    "name": "Shymkent",
    "countryCode": "KZ",
    "stateCode": "1537272",
    "population": 414032,
    "latitude": "42.3",
    "longitude": "69.6",
    "tier": 4
  },
  {
    "name": "Vientiane",
    "countryCode": "LA",
    "stateCode": "24",
    "population": 196731,
    "latitude": "17.96667",
    "longitude": "102.6",
    "tier": 4
  },
  {
    "name": "Beirut",
    "countryCode": "LB",
    "stateCode": "04",
    "population": 1916100,
    "latitude": "33.89332",
    "longitude": "35.50157",
    "tier": 4
  },
  {
    "name": "Ra’s Bayrūt",
    "countryCode": "LB",
    "stateCode": "04",
    "population": 1251739,
    "latitude": "33.9",
    "longitude": "35.48333",
    "tier": 4
  },
  {
    "name": "Tripoli",
    "countryCode": "LB",
    "stateCode": "09",
    "population": 229398,
    "latitude": "34.43352",
    "longitude": "35.84415",
    "tier": 4
  },
  {
    "name": "Colombo",
    "countryCode": "LK",
    "stateCode": "36",
    "population": 648034,
    "latitude": "6.93548",
    "longitude": "79.84868",
    "tier": 4
  },
  {
    "name": "Dehiwala-Mount Lavinia",
    "countryCode": "LK",
    "stateCode": "36",
    "population": 219827,
    "latitude": "6.84019",
    "longitude": "79.87116",
    "tier": 4
  },
  {
    "name": "Moratuwa",
    "countryCode": "LK",
    "stateCode": "36",
    "population": 185031,
    "latitude": "6.773",
    "longitude": "79.8816",
    "tier": 4
  },
  {
    "name": "Monrovia",
    "countryCode": "LR",
    "stateCode": "14",
    "population": 939524,
    "latitude": "6.30054",
    "longitude": "-10.7969",
    "tier": 4
  },
  {
    "name": "Maseru",
    "countryCode": "LS",
    "stateCode": "14",
    "population": 118355,
    "latitude": "-29.31667",
    "longitude": "27.48333",
    "tier": 4
  },
  {
    "name": "Vilnius",
    "countryCode": "LT",
    "stateCode": "65",
    "population": 542366,
    "latitude": "54.68916",
    "longitude": "25.2798",
    "tier": 4
  },
  {
    "name": "Kaunas",
    "countryCode": "LT",
    "stateCode": "57",
    "population": 374643,
    "latitude": "54.90272",
    "longitude": "23.90961",
    "tier": 4
  },
  {
    "name": "Klaipėda",
    "countryCode": "LT",
    "stateCode": "58",
    "population": 192307,
    "latitude": "55.7068",
    "longitude": "21.13912",
    "tier": 4
  },
  {
    "name": "Riga",
    "countryCode": "LV",
    "stateCode": "25",
    "population": 742572,
    "latitude": "56.946",
    "longitude": "24.10589",
    "tier": 4
  },
  {
    "name": "Daugavpils",
    "countryCode": "LV",
    "stateCode": "07",
    "population": 111564,
    "latitude": "55.88333",
    "longitude": "26.53333",
    "tier": 4
  },
  {
    "name": "Tripoli",
    "countryCode": "LY",
    "stateCode": "77",
    "population": 1150989,
    "latitude": "32.88743",
    "longitude": "13.18733",
    "tier": 4
  },
  {
    "name": "Benghazi",
    "countryCode": "LY",
    "stateCode": "69",
    "population": 650629,
    "latitude": "32.11486",
    "longitude": "20.06859",
    "tier": 4
  },
  {
    "name": "Mişrātah",
    "countryCode": "LY",
    "stateCode": "72",
    "population": 386120,
    "latitude": "32.37535",
    "longitude": "15.09254",
    "tier": 4
  },
  {
    "name": "Casablanca",
    "countryCode": "MA",
    "stateCode": "06",
    "population": 3144909,
    "latitude": "33.58831",
    "longitude": "-7.61138",
    "tier": 4
  },
  {
    "name": "Rabat",
    "countryCode": "MA",
    "stateCode": "04",
    "population": 1655753,
    "latitude": "34.01325",
    "longitude": "-6.83255",
    "tier": 4
  },
  {
    "name": "Fès",
    "countryCode": "MA",
    "stateCode": "03",
    "population": 964891,
    "latitude": "34.03313",
    "longitude": "-5.00028",
    "tier": 4
  },
  {
    "name": "Chisinau",
    "countryCode": "MD",
    "stateCode": "57",
    "population": 635994,
    "latitude": "47.00556",
    "longitude": "28.8575",
    "tier": 4
  },
  {
    "name": "Tiraspol",
    "countryCode": "MD",
    "stateCode": "58",
    "population": 157000,
    "latitude": "46.84274",
    "longitude": "29.62909",
    "tier": 4
  },
  {
    "name": "Bălţi",
    "countryCode": "MD",
    "stateCode": "60",
    "population": 125000,
    "latitude": "47.76314",
    "longitude": "27.92932",
    "tier": 4
  },
  {
    "name": "Podgorica",
    "countryCode": "ME",
    "stateCode": "16",
    "population": 136473,
    "latitude": "42.44111",
    "longitude": "19.26361",
    "tier": 4
  },
  {
    "name": "Antananarivo",
    "countryCode": "MG",
    "stateCode": "11",
    "population": 1391433,
    "latitude": "-18.91368",
    "longitude": "47.53613",
    "tier": 4
  },
  {
    "name": "Toamasina",
    "countryCode": "MG",
    "stateCode": "31",
    "population": 206373,
    "latitude": "-18.1492",
    "longitude": "49.40234",
    "tier": 4
  },
  {
    "name": "Antsirabe",
    "countryCode": "MG",
    "stateCode": "12",
    "population": 186253,
    "latitude": "-19.86586",
    "longitude": "47.03333",
    "tier": 4
  },
  {
    "name": "Skopje",
    "countryCode": "MK",
    "stateCode": "F6",
    "population": 474889,
    "latitude": "41.99646",
    "longitude": "21.43141",
    "tier": 4
  },
  {
    "name": "Bamako",
    "countryCode": "ML",
    "stateCode": "01",
    "population": 1297281,
    "latitude": "12.65",
    "longitude": "-8",
    "tier": 4
  },
  {
    "name": "Sikasso",
    "countryCode": "ML",
    "stateCode": "06",
    "population": 144786,
    "latitude": "11.31755",
    "longitude": "-5.66654",
    "tier": 4
  },
  {
    "name": "Mopti",
    "countryCode": "ML",
    "stateCode": "04",
    "population": 108456,
    "latitude": "14.4843",
    "longitude": "-4.18296",
    "tier": 4
  },
  {
    "name": "Yangon",
    "countryCode": "MM",
    "stateCode": "17",
    "population": 4477638,
    "latitude": "16.80528",
    "longitude": "96.15611",
    "tier": 4
  },
  {
    "name": "Mandalay",
    "countryCode": "MM",
    "stateCode": "08",
    "population": 1208099,
    "latitude": "21.97473",
    "longitude": "96.08359",
    "tier": 4
  },
  {
    "name": "Nay Pyi Taw",
    "countryCode": "MM",
    "stateCode": "18",
    "population": 925000,
    "latitude": "19.745",
    "longitude": "96.12972",
    "tier": 4
  },
  {
    "name": "Ulan Bator",
    "countryCode": "MN",
    "stateCode": "20",
    "population": 844818,
    "latitude": "47.90771",
    "longitude": "106.88324",
    "tier": 4
  },
  {
    "name": "Macau",
    "countryCode": "MO",
    "stateCode": "02",
    "population": 520400,
    "latitude": "22.20056",
    "longitude": "113.54611",
    "tier": 4
  },
  {
    "name": "Nouakchott",
    "countryCode": "MR",
    "stateCode": "",
    "population": 661400,
    "latitude": "18.08581",
    "longitude": "-15.9785",
    "tier": 4
  },
  {
    "name": "Port Louis",
    "countryCode": "MU",
    "stateCode": "18",
    "population": 155226,
    "latitude": "-20.16194",
    "longitude": "57.49889",
    "tier": 4
  },
  {
    "name": "Beau Bassin-Rose Hill",
    "countryCode": "MU",
    "stateCode": "17",
    "population": 111355,
    "latitude": "-20.23325",
    "longitude": "57.46609",
    "tier": 4
  },
  {
    "name": "Vacoas",
    "countryCode": "MU",
    "stateCode": "17",
    "population": 110000,
    "latitude": "-20.29806",
    "longitude": "57.47833",
    "tier": 4
  },
  {
    "name": "Male",
    "countryCode": "MV",
    "stateCode": "38",
    "population": 103693,
    "latitude": "4.17521",
    "longitude": "73.50916",
    "tier": 4
  },
  {
    "name": "Lilongwe",
    "countryCode": "MW",
    "stateCode": "C",
    "population": 646750,
    "latitude": "-13.96692",
    "longitude": "33.78725",
    "tier": 4
  },
  {
    "name": "Blantyre",
    "countryCode": "MW",
    "stateCode": "S",
    "population": 584877,
    "latitude": "-15.78499",
    "longitude": "35.00854",
    "tier": 4
  },
  {
    "name": "Mzuzu",
    "countryCode": "MW",
    "stateCode": "N",
    "population": 175345,
    "latitude": "-11.46556",
    "longitude": "34.02071",
    "tier": 4
  },
  {
    "name": "Kota Bharu",
    "countryCode": "MY",
    "stateCode": "03",
    "population": 1459994,
    "latitude": "6.12361",
    "longitude": "102.24333",
    "tier": 4
  },
  {
    "name": "Kuala Lumpur",
    "countryCode": "MY",
    "stateCode": "14",
    "population": 1453975,
    "latitude": "3.1412",
    "longitude": "101.68653",
    "tier": 4
  },
  {
    "name": "Klang",
    "countryCode": "MY",
    "stateCode": "12",
    "population": 879867,
    "latitude": "3.03667",
    "longitude": "101.44333",
    "tier": 4
  },
  {
    "name": "Maputo",
    "countryCode": "MZ",
    "stateCode": "11",
    "population": 1191613,
    "latitude": "-25.96553",
    "longitude": "32.58322",
    "tier": 4
  },
  {
    "name": "Matola",
    "countryCode": "MZ",
    "stateCode": "04",
    "population": 675422,
    "latitude": "-25.96222",
    "longitude": "32.45889",
    "tier": 4
  },
  {
    "name": "Beira",
    "countryCode": "MZ",
    "stateCode": "05",
    "population": 530604,
    "latitude": "-19.84361",
    "longitude": "34.83889",
    "tier": 4
  },
  {
    "name": "Windhoek",
    "countryCode": "NA",
    "stateCode": "21",
    "population": 268132,
    "latitude": "-22.55941",
    "longitude": "17.08323",
    "tier": 4
  },
  {
    "name": "Niamey",
    "countryCode": "NE",
    "stateCode": "08",
    "population": 774235,
    "latitude": "13.51366",
    "longitude": "2.1098",
    "tier": 4
  },
  {
    "name": "Zinder",
    "countryCode": "NE",
    "stateCode": "07",
    "population": 191424,
    "latitude": "13.80716",
    "longitude": "8.9881",
    "tier": 4
  },
  {
    "name": "Maradi",
    "countryCode": "NE",
    "stateCode": "04",
    "population": 163487,
    "latitude": "13.5",
    "longitude": "7.10174",
    "tier": 4
  },
  {
    "name": "Lagos",
    "countryCode": "NG",
    "stateCode": "05",
    "population": 9000000,
    "latitude": "6.45407",
    "longitude": "3.39467",
    "tier": 4
  },
  {
    "name": "Kano",
    "countryCode": "NG",
    "stateCode": "29",
    "population": 3626068,
    "latitude": "12.00012",
    "longitude": "8.51672",
    "tier": 4
  },
  {
    "name": "Ibadan",
    "countryCode": "NG",
    "stateCode": "32",
    "population": 3565108,
    "latitude": "7.37756",
    "longitude": "3.90591",
    "tier": 4
  },
  {
    "name": "Managua",
    "countryCode": "NI",
    "stateCode": "10",
    "population": 973087,
    "latitude": "12.13282",
    "longitude": "-86.2504",
    "tier": 4
  },
  {
    "name": "León",
    "countryCode": "NI",
    "stateCode": "08",
    "population": 144538,
    "latitude": "12.43787",
    "longitude": "-86.87804",
    "tier": 4
  },
  {
    "name": "Masaya",
    "countryCode": "NI",
    "stateCode": "11",
    "population": 130113,
    "latitude": "11.97444",
    "longitude": "-86.09417",
    "tier": 4
  },
  {
    "name": "Kathmandu",
    "countryCode": "NP",
    "stateCode": "3",
    "population": 1442271,
    "latitude": "27.70169",
    "longitude": "85.3206",
    "tier": 4
  },
  {
    "name": "Pokhara",
    "countryCode": "NP",
    "stateCode": "4",
    "population": 200000,
    "latitude": "28.26689",
    "longitude": "83.96851",
    "tier": 4
  },
  {
    "name": "Pātan",
    "countryCode": "NP",
    "stateCode": "3",
    "population": 183310,
    "latitude": "27.67658",
    "longitude": "85.31417",
    "tier": 4
  },
  {
    "name": "Muscat",
    "countryCode": "OM",
    "stateCode": "06",
    "population": 797000,
    "latitude": "23.58413",
    "longitude": "58.40778",
    "tier": 4
  },
  {
    "name": "Seeb",
    "countryCode": "OM",
    "stateCode": "06",
    "population": 237816,
    "latitude": "23.67027",
    "longitude": "58.18911",
    "tier": 4
  },
  {
    "name": "Şalālah",
    "countryCode": "OM",
    "stateCode": "08",
    "population": 163140,
    "latitude": "17.01505",
    "longitude": "54.09237",
    "tier": 4
  },
  {
    "name": "Panamá",
    "countryCode": "PA",
    "stateCode": "08",
    "population": 408168,
    "latitude": "8.9936",
    "longitude": "-79.51973",
    "tier": 4
  },
  {
    "name": "San Miguelito",
    "countryCode": "PA",
    "stateCode": "08",
    "population": 321501,
    "latitude": "9.05032",
    "longitude": "-79.47068",
    "tier": 4
  },
  {
    "name": "Juan Díaz",
    "countryCode": "PA",
    "stateCode": "08",
    "population": 100636,
    "latitude": "9.05",
    "longitude": "-79.45",
    "tier": 4
  },
  {
    "name": "Lima",
    "countryCode": "PE",
    "stateCode": "LMA",
    "population": 7737002,
    "latitude": "-12.04318",
    "longitude": "-77.02824",
    "tier": 4
  },
  {
    "name": "Arequipa",
    "countryCode": "PE",
    "stateCode": "04",
    "population": 841130,
    "latitude": "-16.39889",
    "longitude": "-71.535",
    "tier": 4
  },
  {
    "name": "Callao",
    "countryCode": "PE",
    "stateCode": "07",
    "population": 813264,
    "latitude": "-12.05659",
    "longitude": "-77.11814",
    "tier": 4
  },
  {
    "name": "Port Moresby",
    "countryCode": "PG",
    "stateCode": "20",
    "population": 283733,
    "latitude": "-9.47723",
    "longitude": "147.15089",
    "tier": 4
  },
  {
    "name": "Quezon City",
    "countryCode": "PH",
    "stateCode": "NCR",
    "population": 2761720,
    "latitude": "14.6488",
    "longitude": "121.0509",
    "tier": 4
  },
  {
    "name": "Manila",
    "countryCode": "PH",
    "stateCode": "NCR",
    "population": 1600000,
    "latitude": "14.6042",
    "longitude": "120.9822",
    "tier": 4
  },
  {
    "name": "Caloocan City",
    "countryCode": "PH",
    "stateCode": "NCR",
    "population": 1500000,
    "latitude": "14.64953",
    "longitude": "120.96788",
    "tier": 4
  },
  {
    "name": "Karachi",
    "countryCode": "PK",
    "stateCode": "05",
    "population": 11624219,
    "latitude": "24.8608",
    "longitude": "67.0104",
    "tier": 4
  },
  {
    "name": "Lahore",
    "countryCode": "PK",
    "stateCode": "04",
    "population": 6310888,
    "latitude": "31.558",
    "longitude": "74.35071",
    "tier": 4
  },
  {
    "name": "Faisalabad",
    "countryCode": "PK",
    "stateCode": "04",
    "population": 2506595,
    "latitude": "31.41554",
    "longitude": "73.08969",
    "tier": 4
  },
  {
    "name": "San Juan",
    "countryCode": "PR",
    "stateCode": "127",
    "population": 418140,
    "latitude": "18.46633",
    "longitude": "-66.10572",
    "tier": 4
  },
  {
    "name": "Bayamón",
    "countryCode": "PR",
    "stateCode": "021",
    "population": 203499,
    "latitude": "18.39856",
    "longitude": "-66.15572",
    "tier": 4
  },
  {
    "name": "Carolina",
    "countryCode": "PR",
    "stateCode": "031",
    "population": 170404,
    "latitude": "18.38078",
    "longitude": "-65.95739",
    "tier": 4
  },
  {
    "name": "East Jerusalem",
    "countryCode": "PS",
    "stateCode": "WE",
    "population": 428304,
    "latitude": "31.78336",
    "longitude": "35.23388",
    "tier": 4
  },
  {
    "name": "Gaza",
    "countryCode": "PS",
    "stateCode": "GZ",
    "population": 410000,
    "latitude": "31.50161",
    "longitude": "34.46672",
    "tier": 4
  },
  {
    "name": "Khān Yūnis",
    "countryCode": "PS",
    "stateCode": "GZ",
    "population": 173183,
    "latitude": "31.34018",
    "longitude": "34.30627",
    "tier": 4
  },
  {
    "name": "Asunción",
    "countryCode": "PY",
    "stateCode": "22",
    "population": 1482200,
    "latitude": "-25.28646",
    "longitude": "-57.647",
    "tier": 4
  },
  {
    "name": "Ciudad del Este",
    "countryCode": "PY",
    "stateCode": "01",
    "population": 320782,
    "latitude": "-25.50972",
    "longitude": "-54.61111",
    "tier": 4
  },
  {
    "name": "San Lorenzo",
    "countryCode": "PY",
    "stateCode": "06",
    "population": 227876,
    "latitude": "-25.33968",
    "longitude": "-57.50879",
    "tier": 4
  },
  {
    "name": "Doha",
    "countryCode": "QA",
    "stateCode": "01",
    "population": 344939,
    "latitude": "25.28545",
    "longitude": "51.53096",
    "tier": 4
  },
  {
    "name": "Ar Rayyān",
    "countryCode": "QA",
    "stateCode": "06",
    "population": 272465,
    "latitude": "25.29194",
    "longitude": "51.42444",
    "tier": 4
  },
  {
    "name": "Saint-Denis",
    "countryCode": "RE",
    "stateCode": "RE",
    "population": 137195,
    "latitude": "-20.88231",
    "longitude": "55.4504",
    "tier": 4
  },
  {
    "name": "Bucharest",
    "countryCode": "RO",
    "stateCode": "10",
    "population": 1877155,
    "latitude": "44.43225",
    "longitude": "26.10626",
    "tier": 4
  },
  {
    "name": "Sector 3",
    "countryCode": "RO",
    "stateCode": "10",
    "population": 385439,
    "latitude": "44.4234",
    "longitude": "26.16874",
    "tier": 4
  },
  {
    "name": "Sector 6",
    "countryCode": "RO",
    "stateCode": "10",
    "population": 367760,
    "latitude": "44.43579",
    "longitude": "26.01649",
    "tier": 4
  },
  {
    "name": "Belgrade",
    "countryCode": "RS",
    "stateCode": "SE",
    "population": 1273651,
    "latitude": "44.80401",
    "longitude": "20.46513",
    "tier": 4
  },
  {
    "name": "Niš",
    "countryCode": "RS",
    "stateCode": "SE",
    "population": 250000,
    "latitude": "43.32472",
    "longitude": "21.90333",
    "tier": 4
  },
  {
    "name": "Novi Sad",
    "countryCode": "RS",
    "stateCode": "VO",
    "population": 215400,
    "latitude": "45.25167",
    "longitude": "19.83694",
    "tier": 4
  },
  {
    "name": "Moscow",
    "countryCode": "RU",
    "stateCode": "48",
    "population": 10381222,
    "latitude": "55.75222",
    "longitude": "37.61556",
    "tier": 4
  },
  {
    "name": "Saint Petersburg",
    "countryCode": "RU",
    "stateCode": "66",
    "population": 5028000,
    "latitude": "59.93863",
    "longitude": "30.31413",
    "tier": 4
  },
  {
    "name": "Novosibirsk",
    "countryCode": "RU",
    "stateCode": "53",
    "population": 1419007,
    "latitude": "55.0415",
    "longitude": "82.9346",
    "tier": 4
  },
  {
    "name": "Kigali",
    "countryCode": "RW",
    "stateCode": "12",
    "population": 745261,
    "latitude": "-1.94995",
    "longitude": "30.05885",
    "tier": 4
  },
  {
    "name": "Riyadh",
    "countryCode": "SA",
    "stateCode": "10",
    "population": 4205961,
    "latitude": "24.68773",
    "longitude": "46.72185",
    "tier": 4
  },
  {
    "name": "Jeddah",
    "countryCode": "SA",
    "stateCode": "14",
    "population": 2867446,
    "latitude": "21.49012",
    "longitude": "39.18624",
    "tier": 4
  },
  {
    "name": "Mecca",
    "countryCode": "SA",
    "stateCode": "14",
    "population": 1323624,
    "latitude": "21.42664",
    "longitude": "39.82563",
    "tier": 4
  },
  {
    "name": "Khartoum",
    "countryCode": "SD",
    "stateCode": "29",
    "population": 1974647,
    "latitude": "15.55177",
    "longitude": "32.53241",
    "tier": 4
  },
  {
    "name": "Omdurman",
    "countryCode": "SD",
    "stateCode": "29",
    "population": 1200000,
    "latitude": "15.64453",
    "longitude": "32.47773",
    "tier": 4
  },
  {
    "name": "Nyala",
    "countryCode": "SD",
    "stateCode": "49",
    "population": 565734,
    "latitude": "12.04888",
    "longitude": "24.88069",
    "tier": 4
  },
  {
    "name": "Ljubljana",
    "countryCode": "SI",
    "stateCode": "61",
    "population": 272220,
    "latitude": "46.05108",
    "longitude": "14.50513",
    "tier": 4
  },
  {
    "name": "Bratislava",
    "countryCode": "SK",
    "stateCode": "02",
    "population": 423737,
    "latitude": "48.14816",
    "longitude": "17.10674",
    "tier": 4
  },
  {
    "name": "Košice",
    "countryCode": "SK",
    "stateCode": "03",
    "population": 236563,
    "latitude": "48.71395",
    "longitude": "21.25808",
    "tier": 4
  },
  {
    "name": "Freetown",
    "countryCode": "SL",
    "stateCode": "04",
    "population": 802639,
    "latitude": "8.48714",
    "longitude": "-13.2356",
    "tier": 4
  },
  {
    "name": "Bo",
    "countryCode": "SL",
    "stateCode": "03",
    "population": 174354,
    "latitude": "7.96472",
    "longitude": "-11.73833",
    "tier": 4
  },
  {
    "name": "Kenema",
    "countryCode": "SL",
    "stateCode": "01",
    "population": 143137,
    "latitude": "7.87687",
    "longitude": "-11.19025",
    "tier": 4
  },
  {
    "name": "Dakar",
    "countryCode": "SN",
    "stateCode": "01",
    "population": 2476400,
    "latitude": "14.6937",
    "longitude": "-17.44406",
    "tier": 4
  },
  {
    "name": "Pikine",
    "countryCode": "SN",
    "stateCode": "01",
    "population": 874062,
    "latitude": "14.76457",
    "longitude": "-17.39071",
    "tier": 4
  },
  {
    "name": "Touba",
    "countryCode": "SN",
    "stateCode": "03",
    "population": 529176,
    "latitude": "14.85",
    "longitude": "-15.88333",
    "tier": 4
  },
  {
    "name": "Mogadishu",
    "countryCode": "SO",
    "stateCode": "02",
    "population": 2587183,
    "latitude": "2.03711",
    "longitude": "45.34375",
    "tier": 4
  },
  {
    "name": "Hargeysa",
    "countryCode": "SO",
    "stateCode": "20",
    "population": 477876,
    "latitude": "9.56",
    "longitude": "44.065",
    "tier": 4
  },
  {
    "name": "Berbera",
    "countryCode": "SO",
    "stateCode": "20",
    "population": 242344,
    "latitude": "10.43959",
    "longitude": "45.01432",
    "tier": 4
  },
  {
    "name": "Paramaribo",
    "countryCode": "SR",
    "stateCode": "16",
    "population": 223757,
    "latitude": "5.86638",
    "longitude": "-55.16682",
    "tier": 4
  },
  {
    "name": "Juba",
    "countryCode": "SS",
    "stateCode": "11550569",
    "population": 450000,
    "latitude": "4.85165",
    "longitude": "31.58247",
    "tier": 4
  },
  {
    "name": "Winejok",
    "countryCode": "SS",
    "stateCode": "11550582",
    "population": 300000,
    "latitude": "9.01222",
    "longitude": "27.57081",
    "tier": 4
  },
  {
    "name": "Malakal",
    "countryCode": "SS",
    "stateCode": "11550575",
    "population": 160765,
    "latitude": "9.53342",
    "longitude": "31.66049",
    "tier": 4
  },
  {
    "name": "San Salvador",
    "countryCode": "SV",
    "stateCode": "10",
    "population": 525990,
    "latitude": "13.68935",
    "longitude": "-89.18718",
    "tier": 4
  },
  {
    "name": "Soyapango",
    "countryCode": "SV",
    "stateCode": "10",
    "population": 329708,
    "latitude": "13.71024",
    "longitude": "-89.13989",
    "tier": 4
  },
  {
    "name": "Santa Ana",
    "countryCode": "SV",
    "stateCode": "11",
    "population": 176661,
    "latitude": "13.99417",
    "longitude": "-89.55972",
    "tier": 4
  },
  {
    "name": "Aleppo",
    "countryCode": "SY",
    "stateCode": "09",
    "population": 1602264,
    "latitude": "36.20124",
    "longitude": "37.16117",
    "tier": 4
  },
  {
    "name": "Damascus",
    "countryCode": "SY",
    "stateCode": "13",
    "population": 1569394,
    "latitude": "33.5102",
    "longitude": "36.29128",
    "tier": 4
  },
  {
    "name": "Homs",
    "countryCode": "SY",
    "stateCode": "11",
    "population": 775404,
    "latitude": "34.72682",
    "longitude": "36.72339",
    "tier": 4
  },
  {
    "name": "Manzini",
    "countryCode": "SZ",
    "stateCode": "03",
    "population": 110537,
    "latitude": "-26.49884",
    "longitude": "31.38004",
    "tier": 4
  },
  {
    "name": "N'Djamena",
    "countryCode": "TD",
    "stateCode": "21",
    "population": 721081,
    "latitude": "12.10672",
    "longitude": "15.0444",
    "tier": 4
  },
  {
    "name": "Moundou",
    "countryCode": "TD",
    "stateCode": "08",
    "population": 135167,
    "latitude": "8.56667",
    "longitude": "16.08333",
    "tier": 4
  },
  {
    "name": "Sarh",
    "countryCode": "TD",
    "stateCode": "17",
    "population": 102528,
    "latitude": "9.1429",
    "longitude": "18.3923",
    "tier": 4
  },
  {
    "name": "Lomé",
    "countryCode": "TG",
    "stateCode": "24",
    "population": 749700,
    "latitude": "6.12874",
    "longitude": "1.22154",
    "tier": 4
  },
  {
    "name": "Sokodé",
    "countryCode": "TG",
    "stateCode": "22",
    "population": 117811,
    "latitude": "8.98333",
    "longitude": "1.13333",
    "tier": 4
  },
  {
    "name": "Kara",
    "countryCode": "TG",
    "stateCode": "23",
    "population": 104207,
    "latitude": "9.55111",
    "longitude": "1.18611",
    "tier": 4
  },
  {
    "name": "Bangkok",
    "countryCode": "TH",
    "stateCode": "40",
    "population": 5104476,
    "latitude": "13.75398",
    "longitude": "100.50144",
    "tier": 4
  },
  {
    "name": "Samut Prakan",
    "countryCode": "TH",
    "stateCode": "42",
    "population": 388920,
    "latitude": "13.59934",
    "longitude": "100.59675",
    "tier": 4
  },
  {
    "name": "Mueang Nonthaburi",
    "countryCode": "TH",
    "stateCode": "38",
    "population": 291555,
    "latitude": "13.86075",
    "longitude": "100.51477",
    "tier": 4
  },
  {
    "name": "Dushanbe",
    "countryCode": "TJ",
    "stateCode": "04",
    "population": 679400,
    "latitude": "38.53575",
    "longitude": "68.77905",
    "tier": 4
  },
  {
    "name": "Khujand",
    "countryCode": "TJ",
    "stateCode": "03",
    "population": 144865,
    "latitude": "40.28256",
    "longitude": "69.62216",
    "tier": 4
  },
  {
    "name": "Dili",
    "countryCode": "TL",
    "stateCode": "DI",
    "population": 150000,
    "latitude": "-8.55861",
    "longitude": "125.57361",
    "tier": 4
  },
  {
    "name": "Ashgabat",
    "countryCode": "TM",
    "stateCode": "S",
    "population": 727700,
    "latitude": "37.95",
    "longitude": "58.38333",
    "tier": 4
  },
  {
    "name": "Türkmenabat",
    "countryCode": "TM",
    "stateCode": "04",
    "population": 234817,
    "latitude": "39.07328",
    "longitude": "63.57861",
    "tier": 4
  },
  {
    "name": "Daşoguz",
    "countryCode": "TM",
    "stateCode": "03",
    "population": 166500,
    "latitude": "41.83625",
    "longitude": "59.96661",
    "tier": 4
  },
  {
    "name": "Tunis",
    "countryCode": "TN",
    "stateCode": "36",
    "population": 693210,
    "latitude": "36.81897",
    "longitude": "10.16579",
    "tier": 4
  },
  {
    "name": "Sfax",
    "countryCode": "TN",
    "stateCode": "32",
    "population": 277278,
    "latitude": "34.74056",
    "longitude": "10.76028",
    "tier": 4
  },
  {
    "name": "Sousse",
    "countryCode": "TN",
    "stateCode": "23",
    "population": 164123,
    "latitude": "35.82539",
    "longitude": "10.63699",
    "tier": 4
  },
  {
    "name": "Istanbul",
    "countryCode": "TR",
    "stateCode": "34",
    "population": 14804116,
    "latitude": "41.01384",
    "longitude": "28.94966",
    "tier": 4
  },
  {
    "name": "Ankara",
    "countryCode": "TR",
    "stateCode": "68",
    "population": 3517182,
    "latitude": "39.91987",
    "longitude": "32.85427",
    "tier": 4
  },
  {
    "name": "İzmir",
    "countryCode": "TR",
    "stateCode": "35",
    "population": 2500603,
    "latitude": "38.41273",
    "longitude": "27.13838",
    "tier": 4
  },
  {
    "name": "Taipei",
    "countryCode": "TW",
    "stateCode": "04",
    "population": 7871900,
    "latitude": "25.04776",
    "longitude": "121.53185",
    "tier": 4
  },
  {
    "name": "Kaohsiung",
    "countryCode": "TW",
    "stateCode": "02",
    "population": 1519711,
    "latitude": "22.61626",
    "longitude": "120.31333",
    "tier": 4
  },
  {
    "name": "Taichung",
    "countryCode": "TW",
    "stateCode": "04",
    "population": 1040725,
    "latitude": "24.1469",
    "longitude": "120.6839",
    "tier": 4
  },
  {
    "name": "Dar es Salaam",
    "countryCode": "TZ",
    "stateCode": "23",
    "population": 2698652,
    "latitude": "-6.82349",
    "longitude": "39.26951",
    "tier": 4
  },
  {
    "name": "Mwanza",
    "countryCode": "TZ",
    "stateCode": "12",
    "population": 436801,
    "latitude": "-2.51667",
    "longitude": "32.9",
    "tier": 4
  },
  {
    "name": "Zanzibar",
    "countryCode": "TZ",
    "stateCode": "25",
    "population": 403658,
    "latitude": "-6.16394",
    "longitude": "39.19793",
    "tier": 4
  },
  {
    "name": "Kyiv",
    "countryCode": "UA",
    "stateCode": "12",
    "population": 2797553,
    "latitude": "50.45466",
    "longitude": "30.5238",
    "tier": 4
  },
  {
    "name": "Kharkiv",
    "countryCode": "UA",
    "stateCode": "07",
    "population": 1430885,
    "latitude": "49.98081",
    "longitude": "36.25272",
    "tier": 4
  },
  {
    "name": "Dnipro",
    "countryCode": "UA",
    "stateCode": "04",
    "population": 1032822,
    "latitude": "48.4593",
    "longitude": "35.03865",
    "tier": 4
  },
  {
    "name": "Kampala",
    "countryCode": "UG",
    "stateCode": "C",
    "population": 1353189,
    "latitude": "0.31628",
    "longitude": "32.58219",
    "tier": 4
  },
  {
    "name": "Gulu",
    "countryCode": "UG",
    "stateCode": "N",
    "population": 146858,
    "latitude": "2.77457",
    "longitude": "32.29899",
    "tier": 4
  },
  {
    "name": "Lira",
    "countryCode": "UG",
    "stateCode": "N",
    "population": 119323,
    "latitude": "2.2499",
    "longitude": "32.89985",
    "tier": 4
  },
  {
    "name": "Montevideo",
    "countryCode": "UY",
    "stateCode": "10",
    "population": 1270737,
    "latitude": "-34.90328",
    "longitude": "-56.18816",
    "tier": 4
  },
  {
    "name": "Tashkent",
    "countryCode": "UZ",
    "stateCode": "13",
    "population": 1978028,
    "latitude": "41.26465",
    "longitude": "69.21627",
    "tier": 4
  },
  {
    "name": "Namangan",
    "countryCode": "UZ",
    "stateCode": "06",
    "population": 432456,
    "latitude": "40.9983",
    "longitude": "71.67257",
    "tier": 4
  },
  {
    "name": "Samarkand",
    "countryCode": "UZ",
    "stateCode": "10",
    "population": 319366,
    "latitude": "39.65417",
    "longitude": "66.95972",
    "tier": 4
  },
  {
    "name": "Caracas",
    "countryCode": "VE",
    "stateCode": "25",
    "population": 3000000,
    "latitude": "10.48801",
    "longitude": "-66.87919",
    "tier": 4
  },
  {
    "name": "Maracaibo",
    "countryCode": "VE",
    "stateCode": "23",
    "population": 2225000,
    "latitude": "10.66663",
    "longitude": "-71.61245",
    "tier": 4
  },
  {
    "name": "Maracay",
    "countryCode": "VE",
    "stateCode": "04",
    "population": 1754256,
    "latitude": "10.23535",
    "longitude": "-67.59113",
    "tier": 4
  },
  {
    "name": "Ho Chi Minh City",
    "countryCode": "VN",
    "stateCode": "20",
    "population": 3467331,
    "latitude": "10.82302",
    "longitude": "106.62965",
    "tier": 4
  },
  {
    "name": "Hanoi",
    "countryCode": "VN",
    "stateCode": "44",
    "population": 1431270,
    "latitude": "21.0245",
    "longitude": "105.84117",
    "tier": 4
  },
  {
    "name": "Da Nang",
    "countryCode": "VN",
    "stateCode": "78",
    "population": 752493,
    "latitude": "16.06778",
    "longitude": "108.22083",
    "tier": 4
  },
  {
    "name": "Pristina",
    "countryCode": "XK",
    "stateCode": "10097360",
    "population": 550000,
    "latitude": "42.67272",
    "longitude": "21.16688",
    "tier": 4
  },
  {
    "name": "Prizren",
    "countryCode": "XK",
    "stateCode": "10097361",
    "population": 171464,
    "latitude": "42.21389",
    "longitude": "20.73972",
    "tier": 4
  },
  {
    "name": "Mitrovicë",
    "countryCode": "XK",
    "stateCode": "10097358",
    "population": 107045,
    "latitude": "42.88333",
    "longitude": "20.86667",
    "tier": 4
  },
  {
    "name": "Sanaa",
    "countryCode": "YE",
    "stateCode": "16",
    "population": 1937451,
    "latitude": "15.35472",
    "longitude": "44.20667",
    "tier": 4
  },
  {
    "name": "Al Ḩudaydah",
    "countryCode": "YE",
    "stateCode": "08",
    "population": 617871,
    "latitude": "14.79781",
    "longitude": "42.95452",
    "tier": 4
  },
  {
    "name": "Ta‘izz",
    "countryCode": "YE",
    "stateCode": "25",
    "population": 615222,
    "latitude": "13.57952",
    "longitude": "44.02091",
    "tier": 4
  },
  {
    "name": "Cape Town",
    "countryCode": "ZA",
    "stateCode": "11",
    "population": 3433441,
    "latitude": "-33.92584",
    "longitude": "18.42322",
    "tier": 4
  },
  {
    "name": "Durban",
    "countryCode": "ZA",
    "stateCode": "02",
    "population": 3120282,
    "latitude": "-29.8579",
    "longitude": "31.0292",
    "tier": 4
  },
  {
    "name": "Johannesburg",
    "countryCode": "ZA",
    "stateCode": "06",
    "population": 2026469,
    "latitude": "-26.20227",
    "longitude": "28.04363",
    "tier": 4
  },
  {
    "name": "Lusaka",
    "countryCode": "ZM",
    "stateCode": "09",
    "population": 1267440,
    "latitude": "-15.40669",
    "longitude": "28.28713",
    "tier": 4
  },
  {
    "name": "Kitwe",
    "countryCode": "ZM",
    "stateCode": "08",
    "population": 400914,
    "latitude": "-12.80243",
    "longitude": "28.21323",
    "tier": 4
  },
  {
    "name": "Ndola",
    "countryCode": "ZM",
    "stateCode": "08",
    "population": 394518,
    "latitude": "-12.95867",
    "longitude": "28.63659",
    "tier": 4
  },
  {
    "name": "Harare",
    "countryCode": "ZW",
    "stateCode": "10",
    "population": 1542813,
    "latitude": "-17.82772",
    "longitude": "31.05337",
    "tier": 4
  },
  {
    "name": "Bulawayo",
    "countryCode": "ZW",
    "stateCode": "09",
    "population": 699385,
    "latitude": "-20.15",
    "longitude": "28.58333",
    "tier": 4
  },
  {
    "name": "Chitungwiza",
    "countryCode": "ZW",
    "stateCode": "10",
    "population": 340360,
    "latitude": "-18.01274",
    "longitude": "31.07555",
    "tier": 4
  }
]
